import React from 'react';
import { Link, browserHistory } from 'react-router';
import { NoiDungKienNghi } from './sub-view';
import { Dialog, Checkbox } from "@blueprintjs/core";
import moment from 'moment';
import { Toastr } from 'modules/toastr';
import { msg } from 'constants/message';
import { ContainerFileDinhKem } from 'components/upload';
import { ListHistoryRowItem, ListHistoryDetailRowItem } from 'modules/giai-quyet-don/datatable/rowItem';
import DataTable from 'components/data-table';
import { Text, Input, DatePicker, TextArea, InputNumber, InputList, DropDown } from 'components/tt-forms/common';
import { ShowIf, ShowIfCheck } from 'components/utils';
import { header } from 'constants/table';
import {
  RowItemKetQuaTimKiemThanhTra,
  DataTableMultipleSelect,
  RowItemChiTietThanhVienCuocThanhTra,
  DataTableAttachElement,
  RowItemDanhSachThemMoiThanhTra,
  RowItemCanCuCuocThanhTra
} from 'modules/thanh-tra/datatable';
import { ThanhTra, GiaiQuyetDonThu, Danhmuc, Letter, QuanLyVanBan, DuLieuHeThong } from 'api';
import {
  DropDownChonLoaiHinhThanhTra,
  DropDownChonLinhVucThanhTraMultiple,
  DropDownChonCanCuThanhTraLai,
  DropDownMulipleUse
} from 'components/tt-forms';
import { ConfirmDialog } from 'modules/dialog';
import { isEmpty, get, isArray, concat } from 'lodash';
import { DropDownMultipleSelect } from '../../tt-forms/common';

const loaiQuyTrinh = 'THANH_TRA';
let temp = 1;

class ChinhSuaCuocThanhTra extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isKiemTra: false,
      data: [],
      nhomDoiTuongThanhTraId: '',
      nhomDTList: [],
      isOpenDT: false,
      getTenDoiTuong: [],
      idPushCoQuan: [],
      kyTruocChuyenSang: false,
      dataDetail: [],
      tuKhoa: '',
      maSoThue: '',
      isOpenThanhTra: false,
      loading: false,
      isOpen: false,
      isOpenXL: false,
      linhVucId: '',
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
      quanHuyenId: '',
      dsQuanHuyen: [],
      phuongXaId: '',
      dsPhuongXa: [],
      diaChi: '',
      keHoachThanhTra: '',
      tenMotDoiTuongThanhTra: '',
      tenNhieuDoiTuongThanhTra: '',
      cuocThanhTraNhieuDoiTuong: false,
      ketQuaTimKiemList: [],
      tableLoading: false,
      doiTuongSelectedList: [],
      checkAll: false,
      totalSelectedList: [],
      countDoiTuongViPham: 0,
      enableGetThoiHanThanhTra: true,
      showDoiTuongThanhTra: false,
      passPatch: false,
      passPost: false,
      passDelete: false,
      openDialog: false,
      openDialogLuuHoSo: false,
      getDetail: false,
      backConfirm: false,
      hasChange: false,
      textConfirm: '',
      id: this.props.params.id,
      cuocThanhTraId: this.props.params.id,
      taiLieuVanThu: [],
      taiLieuVanThuUpdate: [],
      taiLieuVanThuDelete: [],
      dataFileDinhKem: {
        thongTinCuocThanhTra: [],
        giaHan: [],
        ketThucTTTT: [],
        ketLuanTranhTra: [],
        rutGon: [],
        ThayTheCTT: [],
        BoSungCTT: []
      },
      type: this.props.type,
      dataTaiLieuVanThuDelete: [],

      listTaiLieuVanThuKetLuanThanhTra: [],
      listTaiLieuVanThu: [],

      //sugget value
      open: false,
      valueKetQuaLinhVucThanhTra: '',
      valueKetQuaChucNangCuocThanhTra: '',

      dataThanhTraLai: [],
      dataLinhVucThanhTra: [],
      dataDonViChuTri: [],
      dataCoQuanDieuTra: [],
      dataDonViBanHanh: [],
      dataDonViViPham: [],
      dataLoaiHinhThanhTra: [],
      dataHinhThucThanhTra: [],
      dataThanhVienDoan: [],
      dataVaiTroThanhVienDoan: [],
      dataNamThanhTra: [],
      dataChucNangCuocThanhTra: [],
      dataDoiTuongViPhamHienTai: [],

      danhSachCanCuThanhTraLai: [],
      danhSachDonViThanhTra: [],
      danhSachDonViThanhTraLienQuan: [],
      danhSachDonViViPham: [],

      dataDoiTuongViPham: [],

      listDoiTuongViPham: [],
      listtrangThaiRutGon: [],

      //list tai lieu

      listTaiLieuVanThuGiaHan: [],
      listTaiLieuVanThuThongBaoKetThucTTTT: [],
      listTaiLieuVanThuThongTinCuocThanhTra: [],
      listTaiLieuVanThuThayTheCTT: [],
      listTaiLieuVanThuBoSungCTT: [],
      listTaiLieuKetLuanThanhTraRutGon: [],

      //Info

      keHoachThanhTraInfo: null,
      doiTuongThanhTraInfo: null,

      // State value
      namThanhTra: '',
      namThanhTraQĐ: '',
      ten: '',
      doiTuongThanhTra: '',
      kyThanhTra: '',
      tienDoThanhTra: '',
      tienDoThanhTraType: null,
      noiDungThanhTra: '',
      soQuyetDinhVeViecThanhTra: '',
      ngayRaQuyetDinh: '',
      hinhThucThanhTra: 'DOT_XUAT',
      canCuThanhTraDotXuat: '',
      ngayCongBoQuyetDinhThanhTra: '',
      thoiHanThanhTra: 0,
      ngayHetHanThanhTra: '',
      loaiHinhThanhTra: '',
      canCuThanhTraLai: '',
      chucNangCuocThanhTra: 'HANH_CHINH',
      linhVucThanhTraList: [],
      donViChuTri: '',

      donViPhoiHop: '',
      doiTuongThanhTras: [],
      listThanhVienDoan: [],
      thanhVienDoans: [],
      donViThanhTraLienQuan: '',

      soQuyetDinhGiaHan: '',
      ngayRaQuyetDinhGiaHan: '',
      lyDonGiaHan: '',

      ngayQuyetDinhThayTheCTT: '',
      soCongVanThayTheCTT: '',
      lyDoThayTheCTT: '',

      ngayQuyetDinhBoSungCTT: '',
      soCongVanBoSungCTT: '',
      lyDoBoSungCTT: '',

      soQuyetDinhThanhLapDoan: '',
      ngayRaQuyetDinhThanhLapDoan: '',

      soThongBaoKetThucTTTT: '',
      ngayBanHanhThongBaoKetThucTTTT: '',
      nguoiBanHanhThongBaoKetThucTTTT: '',
      ghiChu: '',

      soKetLuanThanhTra: '',
      ngayBanHanhKetLuanThanhTra: '',
      donViBanHanh: '',
      soQuyetDinhXuLy: '',
      ngayBanHanhQuyetDinhXuLy: '',
      tomTatKetLuanThanhTra: '',

      soVuThamNhung: 0,
      soDoiTuongThamNhung: 0,
      tienThamNhung: 0,
      taiSanKhacThamNhung: 0,
      datThamNhung: 0,
      tienKienNghiThuHoi: 0,
      taiSanKhacKienNghiThuHoi: 0,
      datKienNghiThuHoi: 0,
      tienDaThu: 0,
      taiSanKhacDaThu: 0,
      datDaThu: 0,
      toChucXuLyHanhChinhThamNhung: 0,
      caNhanXuLyHanhChinhThamNhung: 0,
      soNguoiXuLyTrachNhiemDungDau: 0,
      tenNguoi: '',
      trangThaiRutGon: '',
      ngayThucHien: '',

      //Tài liệu đính kèm
      dsTepDinhKem: [],
      dsTepDinhKemRemove: [],
      // state các checkbox
      giaHan: false,
      noiDungKienNghi: false,
      coQuyetDinhGiamSat: false,
      noiDungKienNghiInit: false,
      noiDungThamNhung: false,
      thanhVienDoan: false,

      ngayHetHanThanhTraISO: '',
      getThoiHanThanhTra: false,
      showFile: false,
      showFileGiaHan: false,
      dataSuggest: [],
      isSearch: false,
      confirmState: false,

      checkKetThucThanhTraTrucTiep: null,
      checkKetLuanThanhTra: null,
      hinhThucThanhTraChuyenNganhList: [],
      hinhThucThanhTraChuyenNganh: '',

      //confirm
      confirmDoiTuongViPham: false,
      tenDoiTuongViPhamConfirm: '',
      confirmDoiTuongLienQuan: false,
      tenDoiTuongLienQuanConfirm: '',
      thucHienPhapLuatVeThanhTraListCombobox: [],
      thucHienPhapLuatVeThanhTraList: [],
      chiTietLinhVuc: '',
      DataLichSuQuaTrinhXuLy: [],
      dataSelectDoiTuongCurrent: [],
      doiTuongThanhTraId: '',
      listDanhMucVanBan: [],
      danhMucVanBanCanCu: [],
      soVanBanQuyetDinhGiamSat: '',
      ngayBanHanhQuyetDinhGiamSat: '',
      listTaiLieuQuyetDinhGiamSat: [],
      validLinhVucThanhTra: true
    }
  }

  addNewVanBanCanCu() {
    this.setState({
      ...this.state,
      danhMucVanBanCanCu: [...this.state.danhMucVanBanCanCu, {
        vanBanId: '',
        coQuanBanHanh: '',
        theLoaiVanBan: '',
        linhVucVanBan: '',
        tenFile: '',
        duongDan: '',
      }]
    })
  }

  removeVanBanCanCu(indexRemove) {
    const result = this.state.danhMucVanBanCanCu.filter((item, index) => index !== indexRemove)
    this.setState({
      ...this.state,
      danhMucVanBanCanCu: result
    })
  }

  suggesttion(dataSearch) {
    this.setState({
      isSearch: true
    }, () => {
      let params = {
        tuKhoa: dataSearch,
      }

      if (this.state.doiTuongThanhTra) {
        params.doiTuongIds = this.state.doiTuongThanhTra
      }
      Danhmuc.actions.getDoiTuongThanhTra.request(params).then(res => {
        if (res.data._embedded) {
          this.setState({
            dataSuggest: res.data._embedded.doiTuongThanhTras,
            isSearch: false
          })
        } else {
          this.setState({
            dataSuggest: [],
            isSearch: false
          })
        }
      })
    })
  }

  componentWillMount() {
    this.determinativeVaiTro();
    if (window.debug) {
      console.log('modules/thanh-tra/ChinhSuaCuocThanhTra');
    }
  }

  determinativeVaiTro() {
    let userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};

    if (typeof userInfo == 'undefined') {
      browserHistory.push('/');
    } else {
      this.setState({
        donViChuTri: userInfo.donViId
      })
    }
  }

  getQuanHuyen() {
    DuLieuHeThong.actions.getQuanHuyen.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dsQuanHuyen: res.data._embedded.donViHanhChinhs
        })
      }
    })
  }

  getPhuongXa(quanHuyenId = undefined) {
    if (quanHuyenId) {
      DuLieuHeThong.actions.getPhuongXa.request(null, { cha: quanHuyenId }).then(res => {
        this.setState({
          dsPhuongXa: get(res, 'data._embedded.donViHanhChinhs') || []
        })
      })
    }
  }

  getListDanhMucVanBan() {
    QuanLyVanBan.actions.getListDanhMucVanBan.request().then(res => {
      if (res.data) {
        this.setState({
          listDanhMucVanBan: res.data
        })
      }
    })
  }

  componentDidMount() {
    this.getCanCuThanhTraLai();
    this.getNhomDoiTuong();
    this.getLinhVucThanhTra();
    this.getLinhVuc();
    this.getDonViChuTri();
    this.getTienDoThanhTra();
    this.getCoQuanDieuTra();
    this.getDonViBanHanh();
    this.getLoaiHinhThanhTra();
    this.getDoiTuongThanhTra();
    this.getHinhThucThanhTra();
    this.getVaiTroThanhVienDoan();
    this.getNamThanhTra();
    this.getChucNangCuocThanhTra();
    this.getHinhThucThanhTraChuyenNganh();
    this.getThucHienPhapLuatVeTT();
    this.getTrangThaiThanhTraRutGon();
    this.getQuyTrinhXuLyHistory();
    this.getListDanhMucVanBan();
    this.getQuanHuyen();
    if (this.state.id) {
      this.getDetail(this.state.id);
    } else {
      this.checkFileRequire();
      this.setState({
        getDetail: true
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      type: nextProps.type
    })
    if (this.props.params.id != nextProps.params.id && nextProps.params.id) {
      this.setState({
        id: nextProps.params.id
      }, () => {
        this.getDetail(this.state.id);
      })
    }
  }

  getThucHienPhapLuatVeTT() {
    ThanhTra.actions.getThucHienPhapLuatVeTT.request().then(res => {
      if (res.data) {
        this.setState({
          thucHienPhapLuatVeThanhTraListCombobox: res.data
        });
      }
    });
  }

  getTrangThaiThanhTraRutGon() {
    ThanhTra.actions.getTrangThaiThanhTraRutGon.request().then(res => {
      if (!isEmpty(res.data)) {
        this.setState({
          listtrangThaiRutGon: res.data
        });
      }
    });
  }

  getChucNangCuocThanhTra() {
    ThanhTra.actions.getChucNangCuocThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataChucNangCuocThanhTra: res.data
        });
      }
    })
  }
  getHinhThucThanhTraChuyenNganh() {
    ThanhTra.actions.getHinhThucThanhTraChuyenNganh.request().then(res => {
      if (res.data) {
        this.setState({
          hinhThucThanhTraChuyenNganhList: res.data
        });
      }
    });
  }

  getNhomDoiTuong() {
    ThanhTra.actions.getNhomDoiTuongThanhTras.request().then(res => {
      let nhomDTList = [];
      if (res.data && res.data._embedded) {
        nhomDTList = res.data._embedded.nhomDoiTuongThanhTras;
      }
      this.setState({ nhomDTList });
    });
  }

  getNamThanhTra() {
    ThanhTra.actions.getNamThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataNamThanhTra: res.data
        });
      }
    });
  }

  getCanCuThanhTraLai() {
    ThanhTra.actions.getCanCuThanhTraLai.request().then(res => {
      let dataThanhTraLai = {};
      if (res.data) {
        dataThanhTraLai = res.data;
      }
      this.setState({ dataThanhTraLai });
    });
  }

  getLinhVucThanhTra() {
    ThanhTra.actions.getLinhVucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataLinhVucThanhTra: res.data
        })
      }
    })
  }

  getDonViChuTri() {
    ThanhTra.actions.getDonViChuTri.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDonViChuTri: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getTienDoThanhTra() {
    ThanhTra.actions.getTienDoThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataTienDoThanhTra: res.data
        })
      }
    })
  }

  getCoQuanDieuTra() {
    ThanhTra.actions.getCoQuanDieuTra.request().then(res => {
      if (res.data._embedded) {
        this.setState({
          dataCoQuanDieuTra: res.data._embedded.coQuanQuanLies
        })
      }
    })
  }

  getDonViBanHanh() {
    ThanhTra.actions.getListDonViBanHanh.request().then(res => {
      if (res.data) {
        this.setState({
          dataDonViBanHanh: res.data
        })
      }
    })
  }

  getLoaiHinhThanhTra() {
    ThanhTra.actions.getLoaiHinhThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataLoaiHinhThanhTra: res.data
        })
      }
    })
  }

  getDoiTuongThanhTra() {
    let params = {}
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    if (this.state.doiTuongThanhTras.length > 0) {
      let listDoiTuongThanhTra = '';
      this.state.doiTuongThanhTras.map((item, i) => {
        if (i == 0) {
          listDoiTuongThanhTra = item.id;
        } else {
          listDoiTuongThanhTra = listDoiTuongThanhTra + ',' + item.id;
        }
      })
      params.doiTuongIds = listDoiTuongThanhTra;
      params.namThanhTra = getNamTT;
    }

    ThanhTra.actions.getDoiTuongThanhTra.request({ doiTuongIds: params.doiTuongIds, namThanhTra: getNamTT }).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDoiTuongThanhTra: res.data._embedded.doiTuongThanhTras
        })
      }
    })
  }

  getHinhThucThanhTra() {
    ThanhTra.actions.getHinhThucThanhTra.request().then(res => {
      if (res.data) {
        this.setState({
          dataHinhThucThanhTra: res.data
        })
      }
    })
  }

  getVaiTroThanhVienDoan() {
    ThanhTra.actions.getVaiTroThanhVienDoan.request().then(res => {
      if (res.data) {
        this.setState({
          dataVaiTroThanhVienDoan: res.data
        })
      }
    })
  }

  getDetail(id) {
    ThanhTra.actions.getChiTietCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let Data = res.data;
        let dataDonViThanhTraLienQuan = [];
        let dataDoiTuongThanhTra = [];
        let dataCanCuThanhTraLai = [];
        let dataSelectDonViViPham = [];
        let danhMucVanBansDetail = [];

        if (Data.danhMucVanBans) {
          danhMucVanBansDetail = Data.danhMucVanBans.map(item => ({
            vanBanId: item.danhMucVanBanId,
            coQuanBanHanh: item.coQuanBanHanhInfo.ten,
            theLoaiVanBan: item.loaiVanBanInfo.ten,
            linhVucVanBan: item.linhVucVanBanInfo.ten,
            tenFile: item.documentMetaDataInfo.ten,
            duongDan: item.documentMetaDataInfo.documentId,
          }))
        }

        if (Data.doiTuongThanhTraLienQuan) {
          let data = Data.doiTuongThanhTraLienQuan.split('; ');
          data.map(state => {
            dataDonViThanhTraLienQuan[dataDonViThanhTraLienQuan.length] = {
              ten: state
            }
          })
        }
        /* Tao lai mang list dua vao 2 phan tu tu Data.listDoiTuongThanhTra */
        if (Data.listDoiTuongThanhTra) {
          let data = [...Data.listDoiTuongThanhTra];
          data.map(state => {
            dataDoiTuongThanhTra[dataDoiTuongThanhTra.length] = {
              id: state.doiTuongThanhTraId,
              ten: state.ten
            }
          })
        }
        if (dataDonViThanhTraLienQuan.length > 0) {
          dataDonViThanhTraLienQuan.map(state => {
            dataSelectDonViViPham[dataSelectDonViViPham.length] = {
              giaTri: state.ten,
              ten: state.ten
            }
          })
        }

        let chucNangCuocThanhTra = '';
        if (this.state.type !== 'KE_HOACH') {
          chucNangCuocThanhTra = Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '';
        } else {
          chucNangCuocThanhTra = Data.chucNangCuocThanhTra ? Data.chucNangCuocThanhTra : '';
        }

        this.setState({
          dataDetail: Data,
          dataDonViViPham: dataSelectDonViViPham,
          danhSachDonViThanhTra: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '',
          danhSachDonViViPham: Data.doiTuongViPham ? Data.doiTuongViPham : '',
          ten: Data.ten ? Data.ten : '',
          kyTruocChuyenSang: Data.kyTruocChuyenSang ? Data.kyTruocChuyenSang : false,
          cuocThanhTraNhieuDoiTuong: Data.cuocThanhTraNhieuDoiTuong ? Data.cuocThanhTraNhieuDoiTuong : false,
          tenNhieuDoiTuongThanhTra: Data.tenNhieuDoiTuongThanhTra ? Data.tenNhieuDoiTuongThanhTra : '',
          tenMotDoiTuongThanhTra: Data.tenMotDoiTuongThanhTra ? Data.tenMotDoiTuongThanhTra : '',
          namThanhTra: Data.namThanhTra ? Data.namThanhTra : '',
          doiTuongThanhTraInfo: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo : null,
          doiTuongThanhTra: Data.doiTuongThanhTraInfo ? Data.doiTuongThanhTraInfo.doiTuongThanhTraId : '',
          kyThanhTra: Data.kyThanhTra ? Data.kyThanhTra : '',
          tienDoThanhTra: Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.text : '',
          tienDoThanhTraType: Data.tienDoThanhTraInfo ? Data.tienDoThanhTraInfo.type : null,
          noiDungThanhTra: Data.noiDungThanhTra ? Data.noiDungThanhTra : '',

          soQuyetDinhVeViecThanhTra: Data.soQuyetDinhVeViecThanhTra ? Data.soQuyetDinhVeViecThanhTra : '',
          ngayRaQuyetDinh: Data.ngayRaQuyetDinh ? new Date(Data.ngayRaQuyetDinh) : '',
          hinhThucThanhTra: Data.hinhThucThanhTra ? Data.hinhThucThanhTra : '',
          canCuThanhTraDotXuat: Data.canCuThanhTraDotXuat ? Data.canCuThanhTraDotXuat : '',

          ngayCongBoQuyetDinhThanhTra: Data.ngayCongBoQuyetDinhThanhTra ? new Date(Data.ngayCongBoQuyetDinhThanhTra) : '',
          thoiHanThanhTra: Data.thoiHanThanhTra ? Data.thoiHanThanhTra : '',
          ngayHetHanThanhTra: Data.ngayHetHanThanhTra ? moment(Data.ngayHetHanThanhTra).format('DD/MM/YYYY') : '',
          ngayHetHanThanhTraISO: Data.ngayHetHanThanhTra ? Data.ngayHetHanThanhTra : '',
          loaiHinhThanhTra: Data.loaiHinhThanhTra ? Data.loaiHinhThanhTra : '',
          dataCanCuThanhTraLai: dataCanCuThanhTraLai,
          canCuThanhTraLai: Data.canCuThanhTraLai,

          chucNangCuocThanhTra: chucNangCuocThanhTra ? chucNangCuocThanhTra : '',
          linhVucThanhTraList: Data.linhVucThanhTraList ? Data.linhVucThanhTraList.map(item => item.giaTri) : [],
          donViChuTri: Data.donViChuTriInfo ? Data.donViChuTriInfo.coQuanQuanLyId : '',

          dataDonViPhoiHop: Data.donViPhoiHop ? Data.donViPhoiHop : '',
          DoiTuongThanhTras: Data.listDoiTuongThanhTra ? Data.listDoiTuongThanhTra : '',
          dataDoiTuongThanhTraLienQuan: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '',

          dataDoiTuongViPham: Data.listDoiTuongViPham ? Data.listDoiTuongViPham : [],

          donViPhoiHop: Data.donViPhoiHop ? Data.donViPhoiHop : '',
          doiTuongThanhTras: dataDoiTuongThanhTra.length > 0 ? dataDoiTuongThanhTra : [],
          doiTuongThanhTraLienQuan: Data.doiTuongThanhTraLienQuan ? Data.doiTuongThanhTraLienQuan : '',
          hinhThucThanhTraChuyenNganh: Data.hinhThucThanhTraChuyenNganh || '',
          thucHienPhapLuatVeThanhTraList: Data.thucHienPhapLuatVeThanhTraList ? Data.thucHienPhapLuatVeThanhTraList.map(item => item.giaTri) : [],
          chiTietLinhVuc: Data.chiTietLinhVuc || '',
          giaHan: Data.giaHan,
          soQuyetDinhGiaHan: Data.soQuyetDinhGiaHan ? Data.soQuyetDinhGiaHan : '',
          ngayRaQuyetDinhGiaHan: Data.ngayRaQuyetDinhGiaHan ? new Date(Data.ngayRaQuyetDinhGiaHan) : '',
          lyDonGiaHan: Data.lyDonGiaHan ? Data.lyDonGiaHan : '',

          ngayQuyetDinhThayTheCTT: Data.ngayQuyetDinhThayTheCTT ? new Date(Data.ngayQuyetDinhThayTheCTT) : '',
          soCongVanThayTheCTT: Data.soCongVanThayTheCTT ? Data.soCongVanThayTheCTT : '',
          lyDoThayTheCTT: Data.lyDoThayTheCTT ? Data.lyDoThayTheCTT : '',

          soQuyetDinhThanhLapDoan: Data.soQuyetDinhThanhLapDoan ? Data.soQuyetDinhThanhLapDoan : '',
          ngayRaQuyetDinhThanhLapDoan: Data.ngayRaQuyetDinhThanhLapDoan ? new Date(Data.ngayRaQuyetDinhThanhLapDoan) : '',

          soThongBaoKetThucTTTT: Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : '',
          ngayBanHanhThongBaoKetThucTTTT: Data.ngayBanHanhThongBaoKetThucTTTT ? new Date(Data.ngayBanHanhThongBaoKetThucTTTT) : '',
          nguoiBanHanhThongBaoKetThucTTTT: Data.nguoiBanHanhThongBaoKetThucTTTTInfo ? Data.nguoiBanHanhThongBaoKetThucTTTTInfo.congChucId : '',
          ghiChu: Data.ghiChu ? Data.ghiChu : '',

          trangThaiRutGon: Data.trangThaiThanhTraRutGon ? Data.trangThaiThanhTraRutGon : '',
          ngayThucHien: Data.ngayThucHienThanhTraRutGon ? new Date(Data.ngayThucHienThanhTraRutGon) : '',

          soKetLuanThanhTra: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : '',
          ngayBanHanhKetLuanThanhTra: Data.ngayBanHanhKetLuanThanhTra ? new Date(Data.ngayBanHanhKetLuanThanhTra) : '',
          donViBanHanh: Data.donViBanHanh ? Data.donViBanHanh : '',
          soQuyetDinhXuLy: Data.soQuyetDinhXuLy ? Data.soQuyetDinhXuLy : '',
          ngayBanHanhQuyetDinhXuLy: Data.ngayBanHanhQuyetDinhXuLy ? new Date(Data.ngayBanHanhQuyetDinhXuLy) : '',
          tomTatKetLuanThanhTra: Data.tomTatKetLuanThanhTra ? Data.tomTatKetLuanThanhTra : '',

          noiDungKienNghi: Data.noiDungKienNghi,
          noiDungKienNghiInit: Data.noiDungKienNghi,
          coQuyetDinhGiamSat: Data.coQuyetDinhGiamSat,

          noiDungThamNhung: Data.noiDungThamNhung,

          thanhVienDoan: Data.thanhVienDoan,

          thanhVienDoans: Data.listThanhVienDoan,

          soVuThamNhung: Data.soVuThamNhung ? Data.soVuThamNhung : 0,
          soDoiTuongThamNhung: Data.soDoiTuongThamNhung ? Data.soDoiTuongThamNhung : 0,

          tienThamNhung: Data.tienThamNhung ? Data.tienThamNhung : 0,
          taiSanKhacThamNhung: Data.taiSanKhacThamNhung ? Data.taiSanKhacThamNhung : 0,
          datThamNhung: Data.datThamNhung ? Data.datThamNhung : 0,

          tienKienNghiThuHoi: Data.tienKienNghiThuHoi ? Data.tienKienNghiThuHoi : 0,
          taiSanKhacKienNghiThuHoi: Data.taiSanKhacKienNghiThuHoi ? Data.taiSanKhacKienNghiThuHoi : 0,
          datKienNghiThuHoi: Data.datKienNghiThuHoi ? Data.datKienNghiThuHoi : 0,

          tienDaThu: Data.tienDaThu ? Data.tienDaThu : 0,
          taiSanKhacDaThu: Data.taiSanKhacDaThu ? Data.taiSanKhacDaThu : 0,
          datDaThu: Data.datDaThu ? Data.datDaThu : 0,

          toChucXuLyHanhChinhThamNhung: Data.toChucXuLyHanhChinhThamNhung ? Data.toChucXuLyHanhChinhThamNhung : 0,
          caNhanXuLyHanhChinhThamNhung: Data.caNhanXuLyHanhChinhThamNhung ? Data.caNhanXuLyHanhChinhThamNhung : 0,
          soNguoiXuLyTrachNhiemDungDau: Data.soNguoiXuLyTrachNhiemDungDau ? Data.soNguoiXuLyTrachNhiemDungDau : 0,
          tenNguoi: Data.tenNguoi ? Data.tenNguoi : '',

          checkKetThucThanhTraTrucTiep: Data.soThongBaoKetThucTTTT ? Data.soThongBaoKetThucTTTT : null,
          checkKetLuanThanhTra: Data.soKetLuanThanhTra ? Data.soKetLuanThanhTra : null,
          isKiemTra: Data.loaiCuoc.value === 'KIEM_TRA',
          danhMucVanBanCanCu: danhMucVanBansDetail
        }, () => {
          this.checkListDoiTuongViPham();
        })
      }
    })
    this.getChiTietLienQuanCuocThanhTra(id);
  }

  getChiTietLienQuanCuocThanhTra(id) {
    ThanhTra.actions.getChiTietLienQuanCuocThanhTra.request({ id: id }).then(res => {
      if (res.data) {
        let Data = res.data;
        this.setState({
          listTaiLieuVanThu: Data.listTaiLieuVanThu ? Data.listTaiLieuVanThu : [],
          listTaiLieuVanThuGiaHan: Data.listTaiLieuVanThuGiaHan ? Data.listTaiLieuVanThuGiaHan : [],
          listTaiLieuVanThuKetLuanThanhTra: Data.listTaiLieuVanThuKetLuanThanhTra ? Data.listTaiLieuVanThuKetLuanThanhTra : [],
          listTaiLieuVanThuThongBaoKetThucTTTT: Data.listTaiLieuVanThuThongBaoKetThucTTTT ? Data.listTaiLieuVanThuThongBaoKetThucTTTT : [],
          listTaiLieuQuyetDinhGiamSat: Data.listTaiLieuVanThuQuyetDinhGiamSat ? Data.listTaiLieuVanThuQuyetDinhGiamSat : [],
          listTaiLieuVanThuThongTinCuocThanhTra: Data.listTaiLieuVanThuThongTinCuocThanhTra ? Data.listTaiLieuVanThuThongTinCuocThanhTra : [],
          listTaiLieuVanThuThayTheCTT: Data.listTaiLieuVanThuThayTheCTT ? Data.listTaiLieuVanThuThayTheCTT : [],
          listTaiLieuVanThuBoSungCTT: Data.listTaiLieuVanThuBoSungCTT ? Data.listTaiLieuVanThuBoSungCTT : [],
          listTaiLieuKetLuanThanhTraRutGon: Data.listTaiLieuKetLuanThanhTraRutGon || [],
          getDetail: true
        }, () => {
          this.checkFileRequire();
        })
      }
    })
  }

  checkListDoiTuongViPham() {
    let listDoiTuongViPham = [];
    let doiTuongThanhTraLienQuan = [];
    let doiTuongThanhTras = [...this.state.doiTuongThanhTras];
    let doiTuongThanhTra = this.state.doiTuongThanhTraInfo;
    let data = this.state.dataDoiTuongThanhTraLienQuan.split('; ');

    if (data.length > 0) {
      data.map(state => {
        if (state) {
          doiTuongThanhTraLienQuan[doiTuongThanhTraLienQuan.length] = {
            ten: state
          }
        }
      })
    }
    if (doiTuongThanhTraLienQuan.length > 0) {
      doiTuongThanhTraLienQuan.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTras.length > 0) {
      doiTuongThanhTras.map(state => {
        listDoiTuongViPham[listDoiTuongViPham.length] = {
          ten: state.ten,
          giaTri: state.ten
        }
      })
    }
    if (doiTuongThanhTra) {
      listDoiTuongViPham[listDoiTuongViPham.length] = {
        ten: doiTuongThanhTra.ten,
        giaTri: doiTuongThanhTra.ten
      }
    }
    this.setState({
      listDoiTuongViPham: listDoiTuongViPham
    })
  }

  checkFileRequire() {
    let dataTaiLieuVanThu = [...this.state.listTaiLieuVanThuThongTinCuocThanhTra];
    let dataTaiLieuVanThuFilter = dataTaiLieuVanThu.filter(state => {
      return state.typeRequired == 'TT_QUYET_DINH_THANH_TRA'
    })
    if (dataTaiLieuVanThuFilter.length > 0) {
      // do nothing
    } else {
      let newItem = {
        ten: `Quyết định về việc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`,
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'TT_QUYET_DINH_THANH_TRA',
        newFile: true,
        nhomHoSo: null,
      }
      this.state.listTaiLieuVanThuThongTinCuocThanhTra = [
        ...this.state.listTaiLieuVanThuThongTinCuocThanhTra,
        newItem
      ]
    }

    let dataTaiLieuVanThuThongBaoKetThucTTTT = [...this.state.listTaiLieuVanThuThongBaoKetThucTTTT];
    let dataTaiLieuQuyetDinhGiamSat = [...this.state.listTaiLieuQuyetDinhGiamSat];
    let dataTaiLieuVanThuThongBaoKetThucTTTTFilter = dataTaiLieuVanThuThongBaoKetThucTTTT.filter(state => {
      return state.typeRequired == 'TT_THONG_BAO_KT_TTTT'
    })
    let dataTaiLieuQuyetDinhGiamSatFilter = dataTaiLieuQuyetDinhGiamSat.filter(state => {
      return state.typeRequired == 'TT_THONG_BAO_KT_TTTT'
    })
    if (dataTaiLieuVanThuThongBaoKetThucTTTTFilter.length > 0) {
      // do nothing
    } else {
      let newItem = {
        ten: `Thông báo kết thúc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} trực tiếp`,
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'TT_THONG_BAO_KT_TTTT',
        newFile: true,
        nhomHoSo: null,
      }
      this.state.listTaiLieuVanThuThongBaoKetThucTTTT = [
        ...this.state.listTaiLieuVanThuThongBaoKetThucTTTT,
        newItem
      ]
    }

    if (dataTaiLieuQuyetDinhGiamSatFilter.length > 0) {

    } else {
      let newItem = {
        ten: 'Quyết định giám sát',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'TT_THONG_BAO_KT_TTTT',
        newFile: false,
        nhomHoSo: null,
      }
      this.state.listTaiLieuQuyetDinhGiamSat = [
        ...this.state.listTaiLieuQuyetDinhGiamSat,
        newItem
      ]
    }

    let dataTaiLieuVanThuKetLuanThanhTra = [...this.state.listTaiLieuVanThuKetLuanThanhTra];
    let dataTaiLieuVanThuKetLuanThanhTraFilter = dataTaiLieuVanThuKetLuanThanhTra.filter(state => {
      return state.typeRequired == 'TT_KET_LUAN_THANH_TRA'
    })
    if (dataTaiLieuVanThuKetLuanThanhTraFilter.length > 0) {
      // do nothing
    } else {
      let newItem = {
        ten: `Kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`,
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        typeRequired: 'TT_KET_LUAN_THANH_TRA',
        newFile: true,
        nhomHoSo: null,
      }
      this.state.listTaiLieuVanThuKetLuanThanhTra = [
        ...this.state.listTaiLieuVanThuKetLuanThanhTra,
        newItem
      ]
    }
    let dataTaiLieuVanThuTT = [...this.state.listTaiLieuVanThuThayTheCTT];
    if (dataTaiLieuVanThuTT.length > 0) {
      // do nothing
    } else {
      let newItem = {
        ten: 'Văn bản đính kèm khác',
        loaiTepDinhKem: '',
        soQuyetDinh: '',
        ngayQuyetDinh: '',
        tenFile: '',
        duongDan: '',
        progress: 0,
        required: true,
        newFile: true,
        nhomHoSo: null,
      };
      this.setState({
        listTaiLieuVanThuThayTheCTT: [
          ...this.state.listTaiLieuVanThuThayTheCTT,
          newItem
        ]
      });
    }

    if (this.state.giaHan) {
      let data = [...this.state.listTaiLieuVanThuGiaHan];
      let dataFilter = data.filter(state => {
        return state.typeRequired == 'TT_GIA_HAN'
      })
      if (dataFilter.length > 0) {
        // do nothing
      } else {
        let newItem = {
          ten: 'Quyết định gia hạn',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'TT_GIA_HAN',
          newFile: true,
          nhomHoSo: null,
        }
        this.state.listTaiLieuVanThuGiaHan = [
          ...this.state.listTaiLieuVanThuGiaHan,
          newItem
        ]
      }
    }
    this.setState({
      ...this.state,
      showFile: true,
      showFileGiaHan: true
    })
  }

  checkFileGiaHan() {
    if (this.state.giaHan) {
      let data = [...this.state.listTaiLieuVanThuGiaHan];
      let dataFilter = data.filter(state => {
        return state.typeRequired == 'TT_GIA_HAN'
      })
      if (dataFilter.length > 0) {
        // do nothing
      } else {
        let newItem = {
          ten: 'Quyết định gia hạn',
          loaiTepDinhKem: '',
          soQuyetDinh: '',
          ngayQuyetDinh: '',
          tenFile: '',
          duongDan: '',
          progress: 0,
          required: true,
          typeRequired: 'TT_GIA_HAN',
          newFile: true,
          nhomHoSo: null,
        }
        this.state.listTaiLieuVanThuGiaHan = [
          ...this.state.listTaiLieuVanThuGiaHan,
          newItem
        ]
      }
    }
    this.setState({
      ...this.state,
      showFileGiaHan: true
    })
  }

  checkNoiDungKienNghi() {
    if (this.state.noiDungKienNghiInit == false && this.state.id) {
      this.clearData();
    }
  }

  onFileChangeDK(data) {
    let state = this.state;
    if (state.huongXuLy === 'BO_SUNG_THONG_TIN') {
      state.dsTaiLieuBoSung = data;
    } else {
      state.dsTepDinhKem = data;
    }
    this.setState(state);
  }

  createDSTepDinhKem(cuocId, keHoachId, data, loaiQT, buocGQ) {
    let listAddNew = [];
    let listUpdate = [];
    data.forEach((item, i) => {
      let params = {
        cuocThanhTra: { id: parseInt(cuocId) },
        keHoachThanhTra: { id: keHoachId },
        nhomHoSo: { id: item.nhomHoSo },
        loaiQuyTrinh: loaiQT,
        buocGiaiQuyet: buocGQ
      }
      if (item.ten) {
        params.ten = item.ten;
        params.tenFileds = item.ten;
      }
      if (item.tenFile) {
        params.tenFile = item.tenFile;
      }
      if (item.duongDan) {
        params.duongDan = item.duongDan;
      }
      if (item.required) {
        params.required = true;
      }
      if (item.typeRequired) {
        params.typeRequired = item.typeRequired;
      }
      if (item.soQuyetDinh) {
        params.soQuyetDinh = item.soQuyetDinh;
      }
      if (item.ngayQuyetDinh) {
        params.ngayQuyetDinh = moment(item.ngayQuyetDinh).toISOString();
      }
      if (item.taiLieuVanThuId) {
        params.id = item.taiLieuVanThuId;
        listUpdate.push(params);
      } else {
        listAddNew.push(params);
      }
    });
    if (listAddNew.length) {
      ThanhTra.actions.postTaiLieuVanThuMulti.request('', { taiLieuVanThus: listAddNew });
    }
    if (listUpdate.length) {
      ThanhTra.actions.updateTaiLieuVanThuMulti.request('', { taiLieuVanThus: listUpdate });
    }
  }

  onFileChange(data, type) {
    if (type == 'THONG_TIN_CUOC_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.thongTinCuocThanhTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'THONG_BAO_KET_THUC_THANH_TRA_TRUC_TIEP') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketThucTTTT = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'KET_LUAN_THANH_TRA_RUT_GON') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.rutGon = data;

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;
      dataFileDinhKem.ketLuanTranhTra = data
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }
  }

  onFileRemove(id, data, type) {
    this.setState({
      dataTaiLieuVanThuDelete: [
        ...this.state.dataTaiLieuVanThuDelete,
        id
      ]
    });

    if (type == 'THONG_TIN_CUOC_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.thongTinCuocThanhTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'THAY_THE_CUOC_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;
      dataFileDinhKem.ThayTheCTT = data;
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'BO_SUNG_CUOC_THANH_TRA') {
      let dataFileDinhKem = this.state.dataFileDinhKem;
      dataFileDinhKem.BoSungCTT = data;
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'GIA_HAN') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.giaHan = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type == 'THONG_BAO_KET_THUC_THANH_TRA_TRUC_TIEP') {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketThucTTTT = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else if (type === 'KET_LUAN_THANH_TRA_RUT_GON') {
      let dataFileDinhKem = this.state.dataFileDinhKem;
      dataFileDinhKem.rutGon = data;
      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    } else {
      let dataFileDinhKem = this.state.dataFileDinhKem;

      dataFileDinhKem.ketLuanTranhTra = data

      this.setState({
        dataFileDinhKem: dataFileDinhKem
      });
    }

  }

  handleSave() {
    let startDate = moment(this.state.ngayRaQuyetDinh, 'MM/DD/YYYY').valueOf();
    let endDate = moment(this.state.ngayCongBoQuyetDinhThanhTra, 'MM/DD/YYYY').valueOf();
    const checkLayoutBoSung = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.fromNotifications;
    const checkInfoTTKHTT = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item && this.props.checkBS.state.item.keHoachThanhTraInfo;
    const checKH = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item;
    if (startDate && endDate && startDate <= endDate && this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0 || (!startDate && this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0) || (!endDate && this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0)) {
      this.setState({
        enableGetThoiHanThanhTra: false,
        btnLoading: true,
        btnSaveLoading: true
      });
      let params = this.getParams();
      params.thayDoiTienDo = false;
      params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
      params.danhMucVanBans = this.state.danhMucVanBanCanCu.filter(item => !!item.vanBanId).map(item => ({ id: item.vanBanId }));
      if (this.state.id) {
        this.pushTaiLieu(this.state.id);
        ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(res => {
          if (res.data) {
            this.handleBack(true);
            Toastr(this.checkIsKiemTra() ? msg.saveCuocKTSuccess : msg.saveCuocTTSuccess, 'success');
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({
            btnLoading: false,
            btnSaveLoading: false
          });
        });
      } else {
        ThanhTra.actions.postCuocThanhTra.request({ id: this.state.id }, params).then(res => {
          if (res.data) {
            this.pushTaiLieu(res.data.cuocThanhTraId);
            if (checKH && checKH.hinhThucThanhTraInfo && checKH.hinhThucThanhTraInfo.type === 'THEO_KE_HOACH') {
              if (checkLayoutBoSung === true) {
                if (checkInfoTTKHTT && checkInfoTTKHTT.keHoachThanhTraId) {
                  const loaiQT = 'BOSUNG_THAYTHE_HUY_CUOC_THANH_TRA';
                  const buocGQ = 'BO_SUNG_CUOC_THANH_TRA';
                  this.createDSTepDinhKem(res.data.cuocThanhTraId, checkInfoTTKHTT.keHoachThanhTraId, this.state.dsTepDinhKem, loaiQT, buocGQ);
                }
              }
            }
            this.handleBack(true);
            Toastr(this.checkIsKiemTra() ? msg.saveCuocKTSuccess : msg.saveCuocTTSuccess, 'success');
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
        });
      }
    } else if (this.state.doiTuongThanhTras && this.state.doiTuongThanhTras.length > 0) {
      Toastr('Ngày ra quyết định phải nhỏ hơn hoặc bằng Ngày công bố quyết định', 'warning');
    } else {
      Toastr('Phải chọn ít nhất một đối tượng thanh tra', 'error');
    }
  }

  postProcess() {
    if (this.validateSubmitForm()) {
      this.setState({
        enableGetThoiHanThanhTra: false,
        btnLoading: true
      })
      let params = this.getParams();
      params.thayDoiTienDo = true;
      params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
      params.listDanhMucVanBan = undefined;
      params.danhMucVanBans = this.state.danhMucVanBanCanCu.filter(item => !!item.vanBanId).map(item => ({ id: item.vanBanId }));
      if (this.state.id) {
        this.pushTaiLieu(this.state.id);
        ThanhTra.actions.patchCuocThanhTra.request({ id: this.state.id }, params).then(res => {
          if (res.data) {
            this.handleBack(true);
            if (this.state.tienDoThanhTraType !== 'DANG_TIEN_HANH' && this.state.tienDoThanhTraType !== 'KET_THUC_THANH_TRA_TRUC_TIEP' && this.state.tienDoThanhTraType !== 'DA_BAN_HANH_KET_LUAN') {
              Toastr(this.checkIsKiemTra() ? msg.ttTienHanhKiemTra : msg.ttTienHanhThanhTra, 'success');
            } else if (this.state.tienDoThanhTraType === 'DANG_TIEN_HANH') {
              Toastr(this.checkIsKiemTra() ? msg.ttKetThucKiemTra : msg.ttKetThucThanhTra, 'success');
            }
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({
            btnLoading: false
          })
        });
      } else {
        ThanhTra.actions.postCuocThanhTra.request({ id: this.state.id }, params).then(res => {
          if (res.data) {
            this.pushTaiLieu(res.data.cuocThanhTraId);
            this.handleBack(true);
            if (this.state.tienDoThanhTraType !== 'DANG_TIEN_HANH' && this.state.tienDoThanhTraType !== 'KET_THUC_THANH_TRA_TRUC_TIEP' && this.state.tienDoThanhTraType !== 'DA_BAN_HANH_KET_LUAN') {
              Toastr(this.checkIsKiemTra() ? msg.ttTienHanhKiemTra : msg.ttTienHanhThanhTra, 'success');
            } else if (this.state.tienDoThanhTraType === 'DANG_TIEN_HANH') {
              Toastr(this.checkIsKiemTra() ? msg.ttKetThucKiemTra : msg.ttKetThucThanhTra, 'success');
            }
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({
            btnLoading: false
          })
        });
      }
    }
  }

  handleKetThuc() {
    this.setState({
      enableGetThoiHanThanhTra: false,
      btnLoading: true
    })
    this.pushTaiLieu(this.state.id, 'KET_THUC');
  }

  handleKetThucThanhTra() {
    let params = this.getParams();
    params.thayDoiTienDo = true;
    params.loaiCuoc = this.checkIsKiemTra() ? 'KIEM_TRA' : 'THANH_TRA';
    if (this.state.noiDungKienNghi == true && !this.checkIsKiemTra())
      params.chuyenTheoDoiThucHien = true;
    else params.chuyenTheoDoiThucHien = false;
    if (this.state.coQuyetDinhGiamSat == true) {
      params.coQuyetDinhGiamSat = true;
    }

    let self = this;
    setTimeout(function () {
      ThanhTra.actions.patchCuocThanhTra.request({ id: self.state.id }, params).then(res => {
        self.handleBack(true);
        if (res.data.chuyenTheoDoiThucHien == true)
          Toastr(msg.ttChuyenTheoDoi, 'success')
        else Toastr(msg.ttLuuHoSo, 'success')
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
        self.setState({
          btnLoading: false
        })
      });
    }, 500);
  }

  getParams() {
    const d = new Date();
    const getNam = d.getFullYear() + 1;
    let params = {};
    const checkLayoutBoSung = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.fromNotifications;
    const checkInfoTTKHTT = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item && this.props.checkBS.state.item.keHoachThanhTraInfo;
    const keHoach = params.keHoachThanhTraGocInfo && params.keHoachThanhTraGocInfo.keHoachThanhTraId ? params.keHoachThanhTraGocInfo.keHoachThanhTraId : null;
    const dateNow = new Date();
    const hinhThucThanhTra = this.state.hinhThucThanhTra || null;
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTrungUong = 19;
    if (this.state.id) {
      params = this.state.dataDetail;
    }
    params.kyTruocChuyenSang = this.state.kyTruocChuyenSang ? this.state.kyTruocChuyenSang : false;
    params.namThanhTra = getNam;
    params.ten = this.state.ten ? this.state.ten : '';
    if (this.state.ngayRaQuyetDinh && this.state.ngayCongBoQuyetDinhThanhTra) {
      this.checkDate(this.state.ngayRaQuyetDinh, this.state.ngayCongBoQuyetDinhThanhTra);
    }
    if (this.state.type != 'DOT_XUAT') {
      if (params.doiTuongThanhTraInfo) {
        params.doiTuongThanhTra = {
          id: params.doiTuongThanhTraInfo.doiTuongThanhTraId
        }
      } else {
        params.doiTuongThanhTra = null
      }
    } else {
      if (this.state.doiTuongThanhTra) {
        params.doiTuongThanhTra = {
          id: Number(this.state.doiTuongThanhTra)
        }
      } else {
        params.doiTuongThanhTra = null
      }
    }
    params.kyTruocChuyenSang = this.state.kyTruocChuyenSang || false;
    params.cuocThanhTraNhieuDoiTuong = this.state.cuocThanhTraNhieuDoiTuong;
    params.tenMotDoiTuongThanhTra = this.state.tenMotDoiTuongThanhTra;
    params.tenNhieuDoiTuongThanhTra = this.state.tenNhieuDoiTuongThanhTra;
    params.kyThanhTra = this.state.kyThanhTra ? this.state.kyThanhTra : '';
    params.noiDungThanhTra = this.state.noiDungThanhTra ? this.state.noiDungThanhTra : '';
    params.soQuyetDinhVeViecThanhTra = this.state.soQuyetDinhVeViecThanhTra ? this.state.soQuyetDinhVeViecThanhTra : '';
    params.ngayRaQuyetDinh = this.state.ngayRaQuyetDinh ? moment(this.state.ngayRaQuyetDinh).add(7, 'hours').toISOString() : null;
    params.hinhThucThanhTra = hinhThucThanhTra;
    if (this.state.hinhThucThanhTra == 'DOT_XUAT') {
      params.canCuThanhTraDotXuat = this.state.canCuThanhTraDotXuat ? this.state.canCuThanhTraDotXuat : '';
    } else {
      params.canCuThanhTraDotXuat = '';
    }

    params.ngayCongBoQuyetDinhThanhTra = this.state.ngayCongBoQuyetDinhThanhTra ? moment(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString() : null;
    params.thoiHanThanhTra = this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0;
    params.ngayHetHanThanhTra = this.state.ngayHetHanThanhTraISO ? this.state.ngayHetHanThanhTraISO : null;
    params.loaiHinhThanhTra = this.state.loaiHinhThanhTra ? this.state.loaiHinhThanhTra : null;
    params.chiTietLinhVuc = this.state.chiTietLinhVuc ? this.state.chiTietLinhVuc : null;

    if (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' && this.state.hinhThucThanhTraChuyenNganh) {
      params.hinhThucThanhTraChuyenNganh = this.state.hinhThucThanhTraChuyenNganh;
    }

    if (this.state.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM') && this.state.thucHienPhapLuatVeThanhTraList) {
      params.thucHienPhapLuatVeThanhTraList = this.state.thucHienPhapLuatVeThanhTraList;
    } else {
      params.thucHienPhapLuatVeThanhTraList = null;
    }

    if (this.state.loaiHinhThanhTra == 'THANH_TRA_LAI') {
      params.canCuThanhTraLai = this.state.canCuThanhTraLai;
    }

    params.chucNangCuocThanhTra = this.state.chucNangCuocThanhTra ? this.state.chucNangCuocThanhTra : null;
    if (this.state.chucNangCuocThanhTra == 'HANH_CHINH') {
      params.linhVucThanhTraList = this.state.linhVucThanhTraList ? this.state.linhVucThanhTraList : null;
    } else {
      params.linhVucThanhTraList = null;
    }

    if (this.state.donViChuTri) {
      params.donViChuTri = {
        id: Number(this.state.donViChuTri)
      }
    } else {
      params.donViChuTri = null;
    }

    params.donViPhoiHop = this.state.donViPhoiHop ? this.state.donViPhoiHop : '';

    params.doiTuongThanhTras = !isEmpty(this.state.doiTuongThanhTras) ? this.state.doiTuongThanhTras.map(item => { return { id: item.id } }) : undefined;

    params.doiTuongThanhTraLienQuan = this.state.doiTuongThanhTraLienQuan ? this.state.doiTuongThanhTraLienQuan : '';

    params.lyDoThayTheCTT = this.state.lyDoThayTheCTT ? this.state.lyDoThayTheCTT : '';

    params.ngayQuyetDinhThayTheCTT = this.state.ngayQuyetDinhThayTheCTT ? moment(this.state.ngayQuyetDinhThayTheCTT).add(7, 'hours').toISOString() : null;

    params.soCongVanThayTheCTT = this.state.soCongVanThayTheCTT ? this.state.soCongVanThayTheCTT : '';

    params.lyDoBoSungCTT = this.state.lyDoBoSungCTT ? this.state.lyDoBoSungCTT : '';

    params.ngayQuyetDinhBoSungCTT = this.state.ngayQuyetDinhBoSungCTT ? moment(this.state.ngayQuyetDinhBoSungCTT).add(7, 'hours').toISOString() : null;

    params.soCongVanBoSungCTT = this.state.soCongVanBoSungCTT ? this.state.soCongVanBoSungCTT : '';
    if (this.state.type === 'KE_HOACH') {
      if (keHoach) {
        const loaiQT = 'BOSUNG_THAYTHE_HUY_CUOC_THANH_TRA';
        const buocGQ = 'THAY_THE_CUOC_THANH_TRA';
        this.createDSTepDinhKem(this.state.cuocThanhTraId, keHoach, this.state.dsTepDinhKem, loaiQT, buocGQ);
      }
    }

    if (checkLayoutBoSung === true) {
      params.hinhThucThanhTra = 'THEO_KE_HOACH';
      params.keHoachThanhTra = checkInfoTTKHTT && checkInfoTTKHTT.keHoachThanhTraId;
    }

    if (this.state.giaHan) {
      params.giaHan = true;
      params.soQuyetDinhGiaHan = this.state.soQuyetDinhGiaHan ? this.state.soQuyetDinhGiaHan : '';
      params.ngayRaQuyetDinhGiaHan = this.state.ngayRaQuyetDinhGiaHan ? moment(this.state.ngayRaQuyetDinhGiaHan).add(7, 'hours').toISOString() : null;
      params.lyDonGiaHan = this.state.lyDonGiaHan ? this.state.lyDonGiaHan : '';
    } else {
      params.giaHan = false;
      params.soQuyetDinhGiaHan = '';
      params.ngayRaQuyetDinhGiaHan = null;
      params.lyDonGiaHan = '';
    }

    if (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' && this.state.thanhVienDoan) {
      let thanhVienDoans = [];
      if (this.state.thanhVienDoans.length > 0) {
        this.state.thanhVienDoans.map(state => {
          let newItem = {
            chucVu: state.chucVu ? state.chucVu : '',
            donVi: state.donVi ? state.donVi : '',
            hoVaTen: state.hoVaTen ? state.hoVaTen : '',
            ngaySinh: state.ngaySinh ? moment(new Date(state.ngaySinh)).add(7, 'hours').toISOString() : '',
            vaiTroThanhVienDoan: state.vaiTroThanhVienDoan ? state.vaiTroThanhVienDoan : null,
          }
          if (state.thanhVienDoanId) {
            newItem.id = Number(state.thanhVienDoanId)
          }
          thanhVienDoans[thanhVienDoans.length] = newItem;
        })
      }
      params.soQuyetDinhThanhLapDoan = this.state.soQuyetDinhThanhLapDoan ? this.state.soQuyetDinhThanhLapDoan : '';
      params.ngayRaQuyetDinhThanhLapDoan = this.state.ngayRaQuyetDinhThanhLapDoan ? moment(this.state.ngayRaQuyetDinhThanhLapDoan).add(7, 'hours').toISOString() : null;

      params.thanhVienDoan = true;
      params.thanhVienDoans = thanhVienDoans;
    } else {
      params.soQuyetDinhThanhLapDoan = '';
      params.ngayRaQuyetDinhThanhLapDoan = null;

      params.thanhVienDoan = false;
      params.thanhVienDoans = [];
    }

    if (userInfo.capCoQuanQuanLyId === TTTrungUong) {
      params.ngayBanHanhThongBaoKetThucTTTT = moment(dateNow).add(7, 'hours').toISOString() || null;
    } else {
      params.ngayBanHanhThongBaoKetThucTTTT = this.state.ngayBanHanhThongBaoKetThucTTTT ? moment(this.state.ngayBanHanhThongBaoKetThucTTTT).add(7, 'hours').toISOString() : null;
    }
    params.soThongBaoKetThucTTTT = this.state.soThongBaoKetThucTTTT ? this.state.soThongBaoKetThucTTTT : '';
    params.nguoiBanHanhThongBaoKetThucTTTT = this.state.nguoiBanHanhThongBaoKetThucTTTT ? { id: this.state.nguoiBanHanhThongBaoKetThucTTTT } : null;
    params.ghiChu = this.state.ghiChu ? this.state.ghiChu : '';

    params.trangThaiThanhTraRutGon = this.state.trangThaiRutGon || null;
    params.ngayThucHienThanhTraRutGon = this.state.ngayThucHien ? moment(this.state.ngayThucHien).add(7, 'hours').toISOString() : null;

    params.soKetLuanThanhTra = this.state.soKetLuanThanhTra ? this.state.soKetLuanThanhTra : '';
    params.ngayBanHanhKetLuanThanhTra = this.state.ngayBanHanhKetLuanThanhTra ? moment(this.state.ngayBanHanhKetLuanThanhTra).add(7, 'hours').toISOString() : null;
    params.donViBanHanh = this.state.donViBanHanh ? this.state.donViBanHanh : null;
    params.soQuyetDinhXuLy = this.state.soQuyetDinhXuLy ? this.state.soQuyetDinhXuLy : '';
    params.ngayBanHanhQuyetDinhXuLy = this.state.ngayBanHanhQuyetDinhXuLy ? moment(this.state.ngayBanHanhQuyetDinhXuLy).add(7, 'hours').toISOString() : null;
    params.tomTatKetLuanThanhTra = this.state.tomTatKetLuanThanhTra ? this.state.tomTatKetLuanThanhTra : '';

    params.noiDungKienNghi = this.state.noiDungKienNghi;

    if (this.state.noiDungKienNghi == false && this.state.id) {
      this.clearData()
    }

    params.coQuyetDinhGiamSat = this.state.coQuyetDinhGiamSat

    if (params.tienDoThanhTraInfo) {
      if (this.state.noiDungKienNghi === true) {
        params.tienDoThanhTra = params.tienDoThanhTraInfo.type;
      } else if (this.state.openDialogLuuHoSo === true && this.state.noiDungKienNghi === false && this.state.tienDoThanhTraType === 'KET_THUC_THANH_TRA_TRUC_TIEP') {
        params.tienDoThanhTra = 'LUU_HO_SO';
      }
    } else {
      params.tienDoThanhTra = null;
    }

    if (this.state.openDialogLuuHoSo === true && !!this.state.id && this.checkIsKiemTra() && this.state.tienDoThanhTraType === 'DANG_TIEN_HANH') {
      params.tienDoThanhTra = 'LUU_HO_SO';
    }

    if (this.state.noiDungThamNhung) {
      params.noiDungThamNhung = true;
      params.soVuThamNhung = this.state.soVuThamNhung ? Number(this.state.soVuThamNhung) : 0;
      params.soDoiTuongThamNhung = this.state.soDoiTuongThamNhung ? Number(this.state.soDoiTuongThamNhung) : 0;
      params.tienThamNhung = this.state.tienThamNhung ? Number(this.state.tienThamNhung) : 0;
      params.taiSanKhacThamNhung = this.state.taiSanKhacThamNhung ? Number(this.state.taiSanKhacThamNhung) : 0;
      params.datThamNhung = this.state.datThamNhung ? Number(this.state.datThamNhung) : 0;
      params.tienKienNghiThuHoi = this.state.tienKienNghiThuHoi ? Number(this.state.tienKienNghiThuHoi) : 0;
      params.taiSanKhacKienNghiThuHoi = this.state.taiSanKhacKienNghiThuHoi ? Number(this.state.taiSanKhacKienNghiThuHoi) : 0;
      params.datKienNghiThuHoi = this.state.datKienNghiThuHoi ? Number(this.state.datKienNghiThuHoi) : 0;
      params.tienDaThu = this.state.tienDaThu ? Number(this.state.tienDaThu) : 0;
      params.taiSanKhacDaThu = this.state.taiSanKhacDaThu ? Number(this.state.taiSanKhacDaThu) : 0;
      params.datDaThu = this.state.datDaThu ? Number(this.state.datDaThu) : 0;
      params.toChucXuLyHanhChinhThamNhung = this.state.toChucXuLyHanhChinhThamNhung ? Number(this.state.toChucXuLyHanhChinhThamNhung) : 0;
      params.caNhanXuLyHanhChinhThamNhung = this.state.caNhanXuLyHanhChinhThamNhung ? Number(this.state.caNhanXuLyHanhChinhThamNhung) : 0;
      params.soNguoiXuLyTrachNhiemDungDau = this.state.soNguoiXuLyTrachNhiemDungDau ? Number(this.state.soNguoiXuLyTrachNhiemDungDau) : 0;
      params.tenNguoi = this.state.tenNguoi ? this.state.tenNguoi : '';
    } else {
      params.noiDungThamNhung = false;
      params.soVuThamNhung = 0;
      params.soDoiTuongThamNhung = 0;
      params.tienThamNhung = 0;
      params.taiSanKhacThamNhung = 0;
      params.datThamNhung = 0;
      params.tienKienNghiThuHoi = 0;
      params.taiSanKhacKienNghiThuHoi = 0;
      params.datKienNghiThuHoi = 0;
      params.tienDaThu = 0;
      params.taiSanKhacDaThu = 0;
      params.datDaThu = 0;
      params.toChucXuLyHanhChinhThamNhung = 0;
      params.caNhanXuLyHanhChinhThamNhung = 0;
      params.soNguoiXuLyTrachNhiemDungDau = 0;
      params.tenNguoi = '';
    }

    if (params.danhMucVanBans) {
      params.danhMucVanBans = this.state.danhMucVanBanCanCu.filter(item => !!item.vanBanId).map(item => ({ id: item.vanBanId }));
    }

    if (params.keHoachThanhTraInfo) {
      params.keHoachThanhTra = {
        id: params.keHoachThanhTraInfo.keHoachThanhTraId
      }
    } else {
      params.keHoachThanhTra = null
    }
    if (params.keHoachThanhTraSearchInfo) {
      params.keHoachThanhTraSearchInfo = {
        id: params.keHoachThanhTraSearchInfo.keHoachThanhTraId
      }
    } else {
      params.keHoachThanhTraSearchInfo = null
    }

    if (params.keHoachThanhTraCuInfo) {
      params.keHoachThanhTraCu = {
        id: params.keHoachThanhTraCuInfo.keHoachThanhTraId
      }
    } else {
      params.keHoachThanhTraCu = null
    }
    delete params['_links'];
    delete params['nguoiSuaInfo'];
    delete params['nguoiTaoInfo'];
    delete params['ngaySua'];
    delete params['ngayTao'];
    delete params['coQuanDieuTraInfo'];
    delete params['doiTuongThanhTraInfo'];
    delete params['donViChuTriInfo'];
    delete params['keHoachThanhTraInfo'];
    delete params['donViInfo'];
    delete params['hinhThucThanhTraInfo'];
    delete params['linhVucThanhTraInfo'];
    delete params['loaiHinhThanhTraInfo'];
    delete params['listTaiLieuVanThu'];
    delete params['listTaiLieuVanThuGiaHan'];
    delete params['listTaiLieuVanThuKetLuanThanhTra'];
    delete params['cuocThanhTraId'];
    delete params['listThanhVienDoan'];
    delete params['tienDoThanhTraInfo'];
    delete params['thoiHanThanhTraInfo'];
    delete params['listTaiLieuVanThuThongBaoKetThucTTTT'];
    delete params['listTaiLieuVanThuThongTinCuocThanhTra'];
    delete params['listTaiLieuVanThuThayTheCTT'];
    delete params['listTaiLieuVanThuBoSungCTT'];
    delete params['listDoiTuongThanhTra'];
    delete params['chucNangCuocThanhTraInfo'];
    delete params['listDoiTuongViPham'];
    delete params['thucHienPhapLuatVeThanhTraInfo'];
    delete params['keHoachThanhTraCuInfo'];
    delete params['keHoachThanhTraGocInfo'];
    delete params['nguoiBanHanhThongBaoKetThucTTTTInfo'];
    delete params['keHoachThanhTraSearchInfo'];
    delete params['linhVucThanhTraChiTietInfo'];
    delete params['hinhThucThanhTraChuyenNganhInfo'];
    delete params['thucHienPhapLuatVeThanhTraInfo'];
    delete params['listTaiLieuXuLyCuocThanhTra'];
    delete params['listTaiLieuKetQuaThucHienKetLuanThanhTra'];
    delete params['listTaiLieuChiDaoCuaCapTren'];

    return params;
  }

  validateSubmitForm() {
    let pass = true;
    this.props.validators['formTaoDon'].map(validator => {
      if (pass)
        pass = validator.validate();
      else {
        validator.validate();
      }
    });
    if (this.state.doiTuongThanhTras.length === 0) {
      Toastr('Phải chọn ít nhất một đối tượng thanh tra', 'error');
      pass = false;
    }
    if (this.state.chucNangCuocThanhTra == 'HANH_CHINH' && isEmpty(this.state.linhVucThanhTraList)) {
      this.setState({ validLinhVucThanhTra: false });
      pass = false;
    }

    return pass;
  }

  clearData() {
    ThanhTra.actions.getDoiTuongViPham.request({ cuocThanhTraId: this.state.cuocThanhTraId }).then(res => {
      if (res.data._embedded) {
        let dataDoiTuongViPham = res.data._embedded.doiTuongViPhams
        let params = { doiTuongViPhams: [] }
        dataDoiTuongViPham.map(item => {
          params.doiTuongViPhams[params.doiTuongViPhams.length] = {
            id: item.doiTuongViPhamId
          }
        })
        ThanhTra.actions.deleteDoiTuongViPham.request('', params).then(res => {
        });
      }
    })
  }

  componentWillUnmount() {


  }

  onChangeDiaChi(e) {
    this.state.diaChi = e.target.value;
  }

  onChange(name, e) {
    if (name == 'nhomDoiTuongThanhTraId') {
      this.setState({
        nhomDoiTuongThanhTraId: e.target.value
      });
    }
    if (name == 'quanHuyenId') {
      if (!e.target.value) {
        this.setState({
          quanHuyenId: e.target.value,
          phuongXaId: '',
          dsPhuongXa: [],
        })
      } else {
        this.getPhuongXa(e.target.value);
        this.setState({
          quanHuyenId: e.target.value,
        })
      }
    }
    if (name == 'phuongXaId') {
      this.setState({
        phuongXaId: e.target.value,
      })
    }
    if (name == 'linhVucThanhTraList') {
      this.setState({
        validLinhVucThanhTra: true,
        linhVucThanhTraList: e.map(item => item.value),
      })
    } else if (name == 'thucHienPhapLuatVeThanhTraList') {
      this.setState({
        thucHienPhapLuatVeThanhTraList: e.map(item => item.value),
      })
    } else if (name == 'thoiHanThanhTra') {
      this.setState({
        [name]: e.target.value
      }, () => {
        this.getThoiHanThanhTra()
      })
    } else if (name == 'doiTuongThanhTras') {
      if (this.props.params.id) {
        if (e.target.value[e.target.value.length - 1] && temp > 1) {
          this.kiemTraTenDoiTuong(e.target.value[e.target.value.length - 1].id)
        }
        temp++
      } else {
        if (e.target.value[e.target.value.length - 1]) {
          this.kiemTraTenDoiTuong(e.target.value[e.target.value.length - 1].id)
        }
      }

      this.setState({
        [name]: e.target.value
      }, () => {
        this.getDoiTuongThanhTra();
      })
    } else if (name == 'doiTuongThanhTra') {
      if (this.state.namThanhTra)
        this.kiemTraTenDoiTuong(parseInt(e.target.value))
      this.setState({
        [name]: e.target.value
      })
    } else if (name === 'soQuyetDinhVeViecThanhTra') {
      const listTaiLieuVanThuThongTinCuocThanhTraNew = this.state.listTaiLieuVanThuThongTinCuocThanhTra.map((item, index) => {
        if (index === 0) {
          return {
            ...item,
            soQuyetDinh: e.target.value
          }
        } return item
      })
      this.setState({
        [name]: e.target.value,
        listTaiLieuVanThuThongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew,
        dataFileDinhKem: {
          ...this.state.dataFileDinhKem,
          thongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew
        }
      })
    } else {
      this.setState({
        [name]: e.target.value
      })
    }
    this.handleChangeData();
  }

  onChangeTenVanBan(value, count) {
    const itemSelected = this.state.listDanhMucVanBan.filter(item => item.id == value)[0];
    const result = this.state.danhMucVanBanCanCu.map((item, index) => {
      if (count === index + 1) {
        return {
          ...item,
          vanBanId: itemSelected.id,
          coQuanBanHanh: itemSelected.coQuanBanHanh.tenCoQuanBanHanh,
          theLoaiVanBan: itemSelected.loaiVanBan.tenLoaiVanBan,
          linhVucVanBan: itemSelected.linhVucVanBan.tenLinhVucVanBan,
          tenFile: itemSelected.documentMetaData.name,
          duongDan: get(itemSelected, 'documentMetaData.id'),
        }
      } else {
        return item;
      }
    })
    this.setState({
      ...this.state,
      danhMucVanBanCanCu: result
    })
  }

  setCountDoiTuongViPham(count) {
    this.setState({
      countDoiTuongViPham: Number(count)
    })
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      if (name == 'ngayCongBoQuyetDinhThanhTra') {
        this.setState({
          [name]: e._d
        }, () => {
          this.getThoiHanThanhTra()
        })
      } else if (name === "ngayRaQuyetDinh") {
        const listTaiLieuVanThuThongTinCuocThanhTraNew = this.state.listTaiLieuVanThuThongTinCuocThanhTra.map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              ngayQuyetDinh: e._d
            }
          } return item
        })
        this.setState({
          [name]: e._d,
          listTaiLieuVanThuThongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew,
          dataFileDinhKem: {
            ...this.state.dataFileDinhKem,
            thongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew
          }
        })
      } else {
        this.setState({
          [name]: e._d
        })
      }
    } else {
      if (name == 'ngayCongBoQuyetDinhThanhTra') {
        this.setState({
          [name]: e
        }, () => {
          this.getThoiHanThanhTra()
        })
      } else if (name === "ngayRaQuyetDinh") {
        const listTaiLieuVanThuThongTinCuocThanhTraNew = this.state.listTaiLieuVanThuThongTinCuocThanhTra.map((item, index) => {
          if (index === 0) {
            return {
              ...item,
              ngayQuyetDinh: e
            }
          } return item
        })
        this.setState({
          [name]: e,
          listTaiLieuVanThuThongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew,
          dataFileDinhKem: {
            ...this.state.dataFileDinhKem,
            thongTinCuocThanhTra: listTaiLieuVanThuThongTinCuocThanhTraNew
          }
        })
      } else {
        this.setState({
          [name]: e
        })
      }
    }
    this.handleChangeData();
  }

  addDonVi(arr, value, e) {
    if (typeof e != 'undefined') {
      e.preventDefault();
    }
    let newArr = [...this.state[arr]];

    let arrCheck = newArr.filter(state => {
      return state.ten == this.state[value]
    })

    if (this.state[value]) {
      if (arrCheck.length > 0) {
        this.setState({
          [value]: ''
        })
      } else {
        if (arr == 'danhSachDonViThanhTra') {
          let Item = {
            giaTri: this.state[value],
            ten: this.state[value]
          }
          this.setState({
            dataDonViViPham: [
              ...this.state.dataDonViViPham,
              Item
            ]
          })
        }
        let newItem = {
          ten: this.state[value]
        }
        this.setState({
          [arr]: [
            ...this.state[arr],
            newItem
          ],
          [value]: ''
        })
      }
    }
    this.handleChangeData();
    return;
  }

  removeDonVi(arr, index) {
    let newData = [...this.state[arr]];
    newData.splice(index, 1);
    if (arr === 'doiTuongThanhTras' && newData.length > 1) {
      this.state.cuocThanhTraNhieuDoiTuong = true;
    } else {
      this.state.cuocThanhTraNhieuDoiTuong = false;
    }
    this.setState({
      [arr]: newData
    })
    if (arr == 'danhSachDonViThanhTra') {
      let data = [...this.state.dataDonViViPham];

      let dataCheck = data.filter(state => {
        return state.giaTri != this.state.danhSachDonViThanhTra[index].ten
      })

      let dataSelected = [...this.state.danhSachDonViViPham]

      let newDataSelected = dataSelected.filter(state => {
        return state.ten != this.state.danhSachDonViThanhTra[index].ten
      })

      this.setState({
        dataDonViViPham: [
          ...dataCheck
        ],
        danhSachDonViViPham: [
          ...newDataSelected
        ]
      })
    }
    this.handleChangeData();
  }

  handleCheck(name, e) {
    this.setState({
      [name]: e
    })
    if (e && name == 'giaHan') {
      this.setState({
        showFileGiaHan: false
      }, () => {
        this.checkFileGiaHan();
      })
    }
    if (!e) {

    }
    this.handleChangeData();
  }

  kiemTraTenDoiTuong(idDoiTuong, check) {
    let d = new Date();
    let getNam = d.getFullYear() + 1;
    let getTenDoiTuong = '';
    const params = {
      doiTuongThanhTraId: idDoiTuong,
      namThanhTra: getNam,
      thaoTac: this.state.hinhThucThanhTra !== 'THEO_KE_HOACH' ? 'CUOC_THANH_TRA_DOT_XUAT' : undefined
    };
    ThanhTra.actions.getKiemTraDoiTuongTT.request(params).then(res => {
      if (res && res.data) {
        let idPushCoQuan = [];
        res.data._embedded.coQuanQuanLies.map(items => {
          idPushCoQuan.push(items.ten)
        })
        let tenDoiTuong = this.state.ketQuaTimKiemList.find(items => items.doiTuongThanhTraId === idDoiTuong);
        if (this.state.checked && check) {
          this.setState({
            isOpenDT: true,
            getTenDoiTuong: get(tenDoiTuong, 'ten'),
            idPushCoQuan: idPushCoQuan
          });
        }
        if (check === false) {
          let msgWarning = 'Đối tượng thanh tra ' + getTenDoiTuong + ' đã được chọn làm đối tượng thanh tra tại đơn vị: ' + idPushCoQuan;
          Toastr(msgWarning, 'thongbao');
        }
      }
    })
    return 0;
  }

  pushTaiLieu(id, type) {
    let dataFileDinhKem = this.getListDataFileDinhKem();
    if (dataFileDinhKem.length > 0) {
      dataFileDinhKem.map((item, i) => {
        if (item.taiLieuVanThuId) {
          this.state.taiLieuVanThuUpdate[this.state.taiLieuVanThuUpdate.length] = {
            cuocThanhTra: {
              id: Number(id)
            },
            id: item.taiLieuVanThuId,
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.phanLoaiQuyTrinh === 'QUYET_DINH_GIAM_SAT' ? 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA' : item.loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh === "KET_LUAN_THANH_TRA_RUT_GON" ? "KET_LUAN_THANH_TRA_RUT_GON" : item.buocGiaiQuyet,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : '',
            nhomHoSo: item.nhomHoSo ? {
              id: Number(item.nhomHoSo)
            } : get(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: get(item, 'nhomHoSoInfo.nhomHoSoId') } : null
          };
        } else {
          this.state.taiLieuVanThu[this.state.taiLieuVanThu.length] = {
            cuocThanhTra: {
              id: Number(id)
            },
            ten: item.ten,
            soQuyetDinh: item.soQuyetDinh,
            ngayQuyetDinh: item.ngayQuyetDinh ? moment(item.ngayQuyetDinh).add(7, 'hours').toISOString() : null,
            tenFile: item.tenFile,
            duongDan: item.duongDan,
            loaiQuyTrinh: item.phanLoaiQuyTrinh === 'QUYET_DINH_GIAM_SAT' ? 'THEO_DOI_THUC_HIEN_SAU_THANH_TRA' : loaiQuyTrinh,
            buocGiaiQuyet: item.phanLoaiQuyTrinh ? item.phanLoaiQuyTrinh : null,
            required: item.required,
            typeRequired: item.typeRequired ? item.typeRequired : '',
            nhomHoSo: item.nhomHoSo ? {
              id: Number(item.nhomHoSo)
            } : get(item, 'nhomHoSoInfo.nhomHoSoId') ? { id: get(item, 'nhomHoSoInfo.nhomHoSoId') } : null
          };
        }
      });
    }

    if (this.state.dataTaiLieuVanThuDelete.length > 0) {
      this.state.dataTaiLieuVanThuDelete.map(item => {
        this.state.taiLieuVanThuDelete[this.state.taiLieuVanThuDelete.length] = {
          id: item
        };
      });
    }
    if (this.state.taiLieuVanThu.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThu
      }

      GiaiQuyetDonThu.actions.postTaiLieuDinhKem.request('', params).then(res => {
        if (type === 'KET_THUC') {
          this.handleKetThucThanhTra()
        }
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    } else {
      if (type === 'KET_THUC') {
        this.handleKetThucThanhTra()
      }
    }

    if (this.state.taiLieuVanThuUpdate.length > 0) {
      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuUpdate
      }
      GiaiQuyetDonThu.actions.updateTaiLieuDinhKem.request('', params).then(res => {
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }

    if (this.state.taiLieuVanThuDelete.length > 0) {

      let params = {
        taiLieuVanThus: this.state.taiLieuVanThuDelete
      }
      GiaiQuyetDonThu.actions.deleteTaiLieuDinhKem.request('', params).then(res => {
      }).catch(error => {
        if (error.response) {
          Toastr(error.response.data.errors[0].detail, 'error');
        }
      });
    }
  }

  getListDataFileDinhKem() {
    let dataFileDinhKem = []
    let Data = this.state.dataFileDinhKem;

    if (Data.thongTinCuocThanhTra.length > 0) {
      Data.thongTinCuocThanhTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.giaHan.length > 0) {
      Data.giaHan.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.ketThucTTTT.length > 0) {
      Data.ketThucTTTT.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (Data.ketLuanTranhTra.length > 0) {
      Data.ketLuanTranhTra.map(state => {
        dataFileDinhKem[dataFileDinhKem.length] = state
      })
    }

    if (!isEmpty(Data.rutGon)) {
      dataFileDinhKem = concat(dataFileDinhKem, Data.rutGon);
    }

    return dataFileDinhKem;
  }

  addItem() {
    let newItem = {
      hoVaTen: '',
      donVi: '',
      chucVu: '',
      ngaySinh: '',
      vaiTroThanhVienDoan: ''
    }

    this.setState({
      thanhVienDoans: [
        ...this.state.thanhVienDoans,
        newItem
      ]
    })
    this.handleChangeData();
  }

  onItemChange(data, index) {

    this.state.thanhVienDoans[index] = data;
    this.setState({
      thanhVienDoans: this.state.thanhVienDoans
    })
    this.handleChangeData();
  }

  onItemRemove(index) {
    let thanhVienDoans = [...this.state.thanhVienDoans];
    thanhVienDoans.splice(index, 1);
    this.setState({
      thanhVienDoans: thanhVienDoans
    })
    this.handleChangeData();
  }

  getThoiHanThanhTra() {
    if (this.state.enableGetThoiHanThanhTra == true) {
      if (this.state.ngayCongBoQuyetDinhThanhTra) {
        this.setState({
          getThoiHanThanhTra: true
        })
        let params = {
          thoiHanThanhTra: this.state.thoiHanThanhTra ? Number(this.state.thoiHanThanhTra) : 0,
          ngayCongBoQD: moment(this.state.ngayCongBoQuyetDinhThanhTra).add(7, 'hours').toISOString()
        }
        ThanhTra.actions.getThoiHanThanhTra.request('', params).then(res => {
          if (res.data) {
            this.setState({
              ngayHetHanThanhTra: moment(new Date(res.data)).format('DD/MM/YYYY'),
              ngayHetHanThanhTraISO: res.data
            }, () => {
              this.setState({
                getThoiHanThanhTra: false
              })
            })
          }
        }).catch(error => {
          if (error.response) {
            Toastr(error.response.data.errors[0].detail, 'error');
          }
          this.setState({
            getThoiHanThanhTra: false
          })
        });
      } else {
        this.setState({
          ngayHetHanThanhTra: '',
          ngayHetHanThanhTraISO: null
        })
      }
    }
  }

  showDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: true
    })
  }

  hideDoiTuongThanhTra() {
    this.setState({
      showDoiTuongThanhTra: false
    })
  }

  setDoiTuongViPhamHienTai(data) {
    this.setState({
      dataDoiTuongViPhamHienTai: data
    })
  }

  handleConfirmDoiTuongViPham(state) {
    let data = [...this.state.dataDoiTuongViPhamHienTai];
    let dataFilter = data.filter(item => {
      return state.ten == item.ten
    })

    if (dataFilter.length > 0) {
      this.setState({
        confirmDoiTuongViPham: true,
        tenDoiTuongViPhamConfirm: state.ten
      })
      return true
    } else {
      return false
    }
  }

  closeConfirmDoiTuongViPham() {
    this.setState({
      confirmDoiTuongViPham: false
    })
  }

  accessConfirmDoiTuongViPham() {
    this.doiTuongThanhTras.removeDonViConfirm();
    this.noiDungKienNghi.clearDataContain(this.state.tenDoiTuongViPhamConfirm);
    this.setState({
      confirmDoiTuongViPham: false
    })
  }

  handleConfirmDoiTuongLienQuan(state) {
    let data = [...this.state.dataDoiTuongViPhamHienTai];
    let dataFilter = data.filter(item => {
      return state.ten == item.ten
    })

    if (dataFilter.length > 0) {
      this.setState({
        confirmDoiTuongLienQuan: true,
        tenDoiTuongLienQuanConfirm: state.ten
      })
      return true
    } else {
      return false
    }
  }

  closeConfirmDoiTuongLienQuan() {
    this.setState({
      confirmDoiTuongLienQuan: false
    })
  }

  accessConfirmDoiTuongLienQuan() {
    this.doiTuongThanhTraLienQuan.removeDonViConfirm();
    this.noiDungKienNghi.clearDataContain(this.state.tenDoiTuongLienQuanConfirm);
    this.setState({
      confirmDoiTuongLienQuan: false
    })
  }

  openDialog() {
    if (this.validateSubmitForm()) {
      this.setState({
        openDialog: true,
        openDialogLuuHoSo: true
      })
    }
  }

  closeDialog() {
    this.setState({
      openDialog: false,
      openDialogLuuHoSo: false,
      isOpen: false,
      isOpenXL: false
    })
  }

  handleBack(allowBack, type) {
    if (allowBack) {
      if (type == 'close') {
        this.checkNoiDungKienNghi()
        browserHistory.goBack();
      } else {
        browserHistory.goBack();
      }
    } else {
      if (this.state.hasChange) {
        this.state.backConfirm = true;
        this.setState({ ...this.state });
      } else {
        browserHistory.goBack();
      }
    }
  }

  closeConfirmBack() {
    this.state.backConfirm = false;
    this.setState({ ...this.state });
  }

  handleChangeData() {
    this.setState({
      hasChange: true
    })
  }

  onChangeInput(name, e) {
    this.setState({
      [name]: e.target.value
    });
  }

  timKiem(statusTimKiem) {
    this.state.checkAll = false;
    let d = new Date();
    let getNamTT = d.getFullYear() + 1;
    const pageData = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
      sort: 'ngaySua,desc',
    };
    let params = {
      pageData,
      namThanhTra: getNamTT
    };

    if (statusTimKiem) {
      params.pageData.page = 0;
    }

    if (!isEmpty(this.state.doiTuongThanhTras)) {
      const idsDoiTuong = this.state.doiTuongThanhTras.map(item => item.id);
      this.state.doiTuongSelectedList.forEach(item => {
        idsDoiTuong.push(item.doiTuongThanhTraId);
      });
      params.idDoiTuongDaCoCuocs = idsDoiTuong;
    } else {
      const idsDoiTuong = [];
      this.state.doiTuongSelectedList.forEach(item => {
        idsDoiTuong.push(item.doiTuongThanhTraId);
      });
      params.idDoiTuongDaCoCuocs = idsDoiTuong;
    }

    if (this.state.tuKhoa) {
      params.tenDoiTuong = this.state.tuKhoa;
    }
    if (this.state.linhVucId) {
      params.linhVucId = this.state.linhVucId;
    }
    if (this.state.nhomDoiTuongThanhTraId) {
      params.nhomDoiTuongThanhTraId = this.state.nhomDoiTuongThanhTraId;
    }
    if (this.state.quanHuyenId) {
      params.quanHuyenId = this.state.quanHuyenId;
    }
    if (this.state.phuongXaId) {
      params.phuongXaId = this.state.phuongXaId;
    }
    if (this.state.diaChi) {
      params.tuKhoa = this.state.diaChi
    }
    if (!isEmpty(this.state.maSoThue)) {
      params.maSoThue = this.state.maSoThue;
    }
    params.approved = true;
    this.setState({ tableLoading: true });
    Danhmuc.actions.doiTuongThanhTraChuaCoCuoc.request(null, params).then(res => {
      if (res.data._embedded) {
        let data = get(res, 'data._embedded.doiTuongThanhTras');
        if (!isEmpty(this.state.totalSelectedList) && isArray(this.state.totalSelectedList)) {
          const newData = data.map(item => {
            this.state.totalSelectedList.forEach(itemDoiTuong => {
              if (item.doiTuongThanhTraId === itemDoiTuong.doiTuongThanhTraId) {
                item.selected = true;
              }
            });
            return item;
          });
          data = newData;
        }
        this.setState({
          ketQuaTimKiemList: data,
          pageData: res.data.page,
          tableLoading: false
        });
      } else {
        this.setState({
          ketQuaTimKiemList: [],
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          },
          tableLoading: false
        });
      }
    });
  }

  handleSelectedAll() {
    let check = false;
    this.state.checkAll = !this.state.checkAll;
    this.state.ketQuaTimKiemList.forEach((item) => {
      item.selected = this.state.checkAll;
      if (this.state.checkAll) {
        this.state.totalSelectedList.push(item);
        this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
      } else {
        this.state.totalSelectedList = [];
        Toastr(null, 'resetclear');
      }
    });
    this.setState({ ...this.state });
  }

  handleChangePageSize(size) {
    this.state.pageData.size = size;
    this.state.pageData.number = 0;
    this.timKiem();
  }
  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.timKiem();
  }

  hanldeRemove(index) {
    this.state.doiTuongSelectedList.splice(index, 1);
    this.setState({ ...this.state });
  }

  async handleSelectedDoiTuong(item) {
    let check = true;
    item.selected = !item.selected;
    if (item.selected) {
      let newtotalSelectedList = [...this.state.totalSelectedList];
      if (item.daTrung === true) {
        this.setState({
          doiTuongThanhTraId: item.doiTuongThanhTraId
        });
      }
      newtotalSelectedList.push(item);
      await this.setState({
        checked: item.selected,
        totalSelectedList: newtotalSelectedList,
      });
      this.kiemTraTenDoiTuong(item.doiTuongThanhTraId, check);
    } else {
      let newtotalSelectedList = [...this.state.totalSelectedList];
      newtotalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == item.doiTuongThanhTraId) {
          newtotalSelectedList.splice(index, 1);
        }
      });
      // Toastr(null,'newtotalSelectedList');
      this.setState({
        totalSelectedList: newtotalSelectedList
      });
    }
  }

  themVaoCuocTT() {
    this.state.doiTuongSelectedList = [...this.state.doiTuongSelectedList, ...this.state.totalSelectedList];
    this.state.totalSelectedList = [];
    this.setState({ ...this.state });
    this.timKiem();
  }

  openDialogThanhTra() {
    this.timKiem();
    this.state.totalSelectedList = [];
    this.setState({
      isOpen: true
    });
  }

  handleSaveThanhTra() {
    let newItem = [...this.state.doiTuongThanhTras];
    this.state.doiTuongSelectedList.forEach(items => {
      newItem.push({
        id: items.doiTuongThanhTraId,
        ten: items.ten
      });
    });
    if (newItem.length > 1) {
      this.state.cuocThanhTraNhieuDoiTuong = true;
    } else {
      this.state.cuocThanhTraNhieuDoiTuong = false;
    }
    // dataDoiTuongThanhTras
    this.setState({
      doiTuongThanhTras: newItem,
      isOpen: false,
      nhomDoiTuongThanhTraId: ''
    })
    this.state.doiTuongSelectedList = [];
  }

  getLinhVuc() {
    Danhmuc.actions.getLinhVucDoiTuongThanhTra.request().then(res => {
      if (res.data && res.data._embedded) {
        this.state.linhVucList = res.data._embedded.linhVucDoiTuongThanhTras;
      } else {
        this.state.linhVucList = [];
      }
      this.setState({ ...this.state });
    });
  }

  checkDate(stD, endD) {
    let startDate = moment(stD, 'MM/DD/YYYY').valueOf();
    let endDate = moment(endD, 'MM/DD/YYYY').valueOf();
    if (startDate > endDate) {
      Toastr('Ngày ra quyết định phải nhỏ hơn hoặc bằng Ngày công bố quyết định', 'warning');
    }
  }

  changeCheckbox(e) {
    let state = this.state;
    state[e.target.name] = e.target.checked
    this.setState(state);
  }

  toggleDialog() {
    this.setState({ isOpenXL: !this.state.isOpenXL, showDetail: false });
  }

  handleViewDetail(item) {
    this.setState({ itemSelected: item, showDetail: true });
  }

  getQuyTrinhXuLyHistory() {
    Letter.actions.getLichSuDon.request({ id: this.props.donId }).then(res => {
      if (res.data && res.data._embedded) {
        this.setState({ DataLichSuQuaTrinhXuLy: res.data._embedded.lichSuThayDois });
      } else {
        this.setState({ DataLichSuQuaTrinhXuLy: [] });
      }
    });
  }

  closeDialogDT(name) {
    let state = this.state;
    let newtotalSelectedList = [...this.state.totalSelectedList];
    let data = [...this.state.dataSelectDoiTuongCurrent];
    let newketQuaTimKiemList = [...this.state.ketQuaTimKiemList];
    if (this.state.doiTuongThanhTraId) {
      newtotalSelectedList.map((value, index) => {
        if (value.doiTuongThanhTraId == this.state.doiTuongThanhTraId) {
          newtotalSelectedList.splice(index, 1);
          data.splice(index, 1);
        }
      });
    }
    newketQuaTimKiemList.map(item => {
      if (item.doiTuongThanhTraId === this.state.doiTuongThanhTraId) {
        item.selected = false;
      }
    });
    data.map(item => {
      if (item.doiTuongThanhTraId === this.state.doiTuongThanhTraId) {
        item.selected = false;
      }
    });
    state.isOpenDT = false;
    this.setState({
      totalSelectedList: newtotalSelectedList,
      ketQuaTimKiemList: newketQuaTimKiemList,
      dataSelectDoiTuongCurrent: data,
      isOpenDT: false
    });
  }

  openDialogDT() {
    this.setState({
      isOpenDT: true
    });
  }

  onCloseDT() {
    this.setState({
      isOpenDT: false
    });
  }

  checkIsKiemTra() {
    const result = window.location.pathname.includes('kiem-tra') || this.state.isKiemTra;
    return result;
  }

  render() {
    const checkInfoTTKHTT = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.item && this.props.checkBS.state.item.keHoachThanhTraInfo;
    const checkLayout = this.props.check && this.props.check.state && this.props.check.state.fromNotifications;
    const checkLayoutBoSung = this.props.checkBS && this.props.checkBS.state && this.props.checkBS.state.fromNotifications;
    let Data = this.state;
    let DataDetail = this.state.dataDetail;
    let chiTietMotDoiTuong = {};
    if (DataDetail && DataDetail.doiTuongThanhTraInfo) {
      chiTietMotDoiTuong = DataDetail && DataDetail.doiTuongThanhTraInfo;
    } else if (DataDetail && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0) {
      chiTietMotDoiTuong = DataDetail.listDoiTuongThanhTra[0];
    }
    const userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {};
    const TTTrungUong = 19;
    let showTienDoThanhTra = '';
    let title = `Cập nhật thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`;
    if (checkLayout) {
      title = `Thay thế cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`;
    } else if (checkLayoutBoSung) {
      title = `Bổ sung cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`;
    }

    if (userInfo.capCoQuanQuanLyId === TTTrungUong && get(Data, 'tienDoThanhTraType') === "KET_THUC_THANH_TRA_TRUC_TIEP") {
      showTienDoThanhTra = 'Đang tiến hành';
    } else {
      showTienDoThanhTra = get(Data, 'tienDoThanhTra');
    }
    return (
      <div className="center reception-container wrap-block">
        <div className='reception-container'>
          <Dialog
            isOpen={this.state.isOpenDT}
            onClose={this.closeDialogDT.bind(this, 'isOpenDT')}
            title='Thông báo'
            className="reception-dialog delete-dialog wrap-block"
          >
            <div className="pt-dialog-body mb0 hlDialog">
              <div className='pt10 txt-center'>
                {`Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
                <h2>{` "${this.state.getTenDoiTuong}" `}</h2>
                {`đã được chọn làm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} của`} {' '}
                {this.state.idPushCoQuan.join(', ')}
              </div>
              <div className='pb20 txt-center'>
                Bạn có đồng ý thêm
                <h2>{` "${this.state.getTenDoiTuong}" `}</h2>
                vào {this.state.type === "DOT_XUAT" ? `cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} đột xuất` : `kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} không?
              </div>
            </div>
            <div className="box-bottom col-100">
              <Link className="btn-action btn-close action-todo" onClick={this.closeDialogDT.bind(this)}><span>Không</span></Link>
              <Link className="btn-action btn-green action-todo" onClick={this.onCloseDT.bind(this)}><span>Đồng ý</span></Link>
            </div>
          </Dialog>
          <Dialog
            isOpen={this.state.isOpen}
            onClose={this.closeDialog.bind(this, 'isOpen')}
            title={`Cập nhật thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
            className="dialog-them-moi-dttt dialog-default wrap-block">
            <div className='row pl30 pr30'>
              <div className='col-100'>
                <h2 className='title-14 pt20 pb15'>{`1. Tìm kiếm đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
              </div>
              <Input className='col-28' label='Đối tượng' value={this.state.tuKhoa} onChange={this.onChangeInput.bind(this, 'tuKhoa')} name='tuKhoa' placeholder='Nhập tên đối tượng...' />
              <Input className='col-28' label='Mã số thuế' value={this.state.maSoThue} onChange={this.onChangeInput.bind(this, 'maSoThue')} name='maSoThue' placeholder='Nhập mã số thuế...' />
              <DropDown className='col-28' label="Nhóm đối tượng" selectedValue={this.state.nhomDoiTuongThanhTraId} onChange={this.onChange.bind(this, 'nhomDoiTuongThanhTraId')} name='nhomDoiTuongThanhTraId' placeholder
                options={this.state.nhomDTList} keyName="nhomDoiTuongThanhTraId" valueName="ten" />
              <DropDown
                className='col-28'
                label="Huyện/TP"
                selectedValue={this.state.quanHuyenId}
                onChange={this.onChange.bind(this, 'quanHuyenId')}
                name='quanHuyenId'
                placeholder
                options={this.state.dsQuanHuyen} keyName="donViHanhChinhId" valueName="ten"
              />
              <DropDown
                className='col-28'
                label="Phường/Xã"
                selectedValue={this.state.phuongXaId}
                onChange={this.onChange.bind(this, 'phuongXaId')}
                name='phuongXaId'
                placeholder
                options={this.state.dsPhuongXa} keyName="donViHanhChinhId" valueName="ten"
              />
              <Input className='col-28' label="Địa chỉ" value={this.state.diaChi} onChange={this.onChangeDiaChi.bind(this)} name='diaChi' placeholder='Nhập' />
              <div className='col-15 mt22'>
                <Link className='btn-green ml10' onClick={this.timKiem.bind(this, true)}>
                  <i className='tt-search'></i>Tìm kiếm
                </Link>
              </div>
            </div>

            <div className='row pl10 pr10 '>
              <div className='col-100'>
                <h2 className='title-14 pt15 pb15 pr20 pl20'>1.1 Kết quả tìm kiếm</h2>
              </div>
              <div className='pl5 pr5'>
                <DataTableMultipleSelect onDisableCheck onCheck={this.handleSelectedAll.bind(this)} selectAllStatus={this.state.checkAll} header={header.thanhTra.KQTKTMDTTT2} dataList={this.state.ketQuaTimKiemList} tableLoading={this.state.tableLoading} pageData={this.state.pageData} parent={this}>
                  <RowItemKetQuaTimKiemThanhTra />
                </DataTableMultipleSelect>
              </div>
              <div className='col-100 pb20 pt10 txt-center'>
                <Link className="btn-green" onClick={this.themVaoCuocTT.bind(this)}>
                  <i className="tt tt-addfile"></i>{`Thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
                </Link>
              </div>
            </div>
            <div className='row pl10 pr10 '>
              <div className='row pl40 pr40'>
                <span className='line-border mt5 mb0'></span>
              </div>
              <div className='col-100'>
                <h2 className='title-14 pt15 pb15 pr20 pl20'>{`1.2 Danh sách đối tượng sẽ được thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
              </div>
              <div className='pl5 pr5'>
                <DataTable header={header.thanhTra.TMDTTT2} dataList={this.state.doiTuongSelectedList} hideButtonExport={true} hidePagination={true} parent={this} emptyMsg={`Chưa có đối tượng được thêm vào cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}>
                  <RowItemDanhSachThemMoiThanhTra />
                </DataTable>
              </div>
            </div>
            <div className='row pl15 pr15'>
              <span className='line-border mt5 mb0'></span>
            </div>
            <div className="action-form-wrap pt20">
              <div className="box-bottom">
                <Link className="btn-action btn-close" onClick={this.closeDialog.bind(this, 'isOpen')}><span>Đóng</span></Link>
                <Link className="btn-action btn-save" onClick={this.handleSaveThanhTra.bind(this)}><span>Lưu</span></Link>
              </div>
            </div>
          </Dialog>
        </div>
        <ConfirmDialog open={this.state.backConfirm} onClose={this.closeConfirmBack.bind(this)} onSuccess={this.handleBack.bind(this, true)}
          title={msg.confirmBack} />
        <div className="back-foward">
          <Link onClick={this.handleBack.bind(this, false, 'close')} title="">Về trang trước</Link>
        </div>
        <div className="heading">
          <h2 className="heading-title icon-add">
            {title}
          </h2>
        </div>
        <div className="bottom-content">
          <ShowIf condition={this.state.type == 'KE_HOACH'}>
            <section className='wrap-block'>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>{`1. Thông tin kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Text label={`Năm ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} className='col-20' value={`Kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} năm ${DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.namThanhTra : ''}`} />
                <Text label={`Quyết định phê duyệt ${this.checkIsKiemTra() ? 'KHKT' : 'KHTT'}:`} className='col-20' value={DataDetail.keHoachThanhTraInfo ? DataDetail.keHoachThanhTraInfo.quyetDinhPheDuyetKTTT : ''} />
                <Text label='Ngày phê duyệt:' className='col-20' value={DataDetail.keHoachThanhTraInfo && DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh ? moment(DataDetail.keHoachThanhTraInfo.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                {/* Ẩn xem lịch sử */}
                {/* <Link className="itt-history" onClick={this.toggleDialog.bind(this)}>Lịch sử xử lý</Link> */}
                <Dialog
                  isOpen={this.state.isOpenXL}
                  onClose={this.toggleDialog.bind(this)}
                  title="Lịch sử xử lý"
                  className="dialog-history wrap-block panel-popup"
                >
                  <div className="body-dialog-gh">
                    {
                      this.state.showDetail && (
                        <div className="back-foward pl25 mb0">
                          <Link onClick={this.handleBack.bind(this)}>Về trang trước</Link>
                        </div>
                      )
                    }
                    {
                      !this.state.showDetail ?
                        <div className="row pl20 pr20">
                          <DataTable
                            header={header.dialogHistoryXL}
                            dataList={this.state.DataLichSuQuaTrinhXuLy}
                            hidePagination={true}
                            ma={this.props.ma}
                          >
                            <ListHistoryRowItem handleViewDetail={this.handleViewDetail.bind(this)} />
                          </DataTable>
                        </div>
                        :
                        <div className="row pl20 pr20">
                          <DataTable
                            header={header.dialogHistoryDetail}
                            dataList={this.state.itemSelected.listThongTinThayDoi}
                            hidePagination={true}
                          >
                            <ListHistoryDetailRowItem />
                          </DataTable>
                        </div>
                    }
                    <div className="box-bottom col-100 mt5">
                      <Link className="btn-action btn-close action-todo" onClick={this.toggleDialog.bind(this)}><span>Đóng</span></Link>
                    </div>
                  </div>
                </Dialog>
              </div>
            </section>
            {/*end thông tin cuộc thanh tra*/}
            <div className='mt10'>
              <div className='big-border'></div>
            </div>
          </ShowIf>
          {/*Thay thế*/}
          <ShowIf condition={checkLayout == true} titleClass='title-12 lable-title-custom' className='pl35 pr35 mb10 row' name='thayThe' label="Thông tin thay thế cuộc thanh tra">
            <section className='wrap-block'>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>{`2. Thông tin thay thế cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
              </div>
              <div className='row pl30 pr30'>
                <Input className="col-25 mb10" label="Số công văn" placeholder="Nhập..." value={this.state.soCongVanThayTheCTT} onChange={this.onChange.bind(this, 'soCongVanThayTheCTT')} name='soCongVanThayTheCTT' bindValidator={this} channel='formTaoDon' require />
                <DatePicker className="col-25 mb10" label="Ngày quyết định" value={this.state.ngayQuyetDinhThayTheCTT} onChange={this.handleChangeDate.bind(this, 'ngayQuyetDinhThayTheCTT')} name='ngayQuyetDinhThayTheCTT' bindValidator={this} channel='formTaoDon' require />
                <TextArea className="col-100 mb5" label="Lý do:" value={this.state.lyDoThayTheCTT} onChange={this.onChange.bind(this, 'lyDoThayTheCTT')} name='lyDoThayTheCTT' bindValidator={this} channel='formTaoDon' require maxLength={1000} />
              </div>
              <div className='row pl35 pr35'>
                <ContainerFileDinhKem ref='containerFileDinhKem' name='fileDinhKemDon' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuThayTheCTT} disableTopLine={true} phanLoaiQuyTrinh="THAY_THE_CUOC_THANH_TRA" onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChangeDK.bind(this)} />
              </div>
            </section>
            <div className='mt10'>
              <div className='big-border'></div>
            </div>
          </ShowIf>
          {/*end Thay thế*/}
          {/*thông tin cuộc thanh tra*/}
          <section className='wrap-block'>
            <ShowIf condition={this.state.type == 'DOT_XUAT'}>
              <ShowIf condition={checkLayoutBoSung === true}>
                <div className='row pl15 pr15'>
                  <h2 className='title-14 p20'>1. Thông tin kế hoạch thêm mới</h2>
                </div>
                {/* <div className='row pl25 pr25'>
                  <Input className='col-input' label="Quyết định phê duyệt KHTT"  placeholder="Nhập..." require bindValidator={this} channel="formTaoDon" value={this.state.quyetDinhPheDuyetKTTT} onChange={this.onChange.bind(this, 'quyetDinhPheDuyetKTTT')} name='quyetDinhPheDuyetKTTT'/>
                  <DatePicker className='col-input' label="Ngày phê duyệt" bindValidator={this} require channel="formTaoDon" value={this.state.ngayRaQuyetDinh} onChange={ this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} />
                  <DropDownMulipleUse label="Năm thanh tra" className='col-25' data={this.state.dataNamThanhTra} selectedValue={this.state.namThanhTraQĐ} onChange={this.onChange.bind(this, 'namThanhTraQĐ')} name='namThanhTraQĐ' keyName='giaTri' valueName='ten' require bindValidator={this} channel="formTaoDon"/>
                </div> */}
                <div className='row pl25 pr25'>
                  <Text label={`Quyết định phê duyệt ${this.checkIsKiemTra() ? 'KHKT' : 'KHTT'}`} className='col-20' value={checkInfoTTKHTT && checkInfoTTKHTT.quyetDinhPheDuyetKTTT ? checkInfoTTKHTT.quyetDinhPheDuyetKTTT : ''} />
                  <Text label="Ngày phê duyệt" className='col-20' value={checkInfoTTKHTT && checkInfoTTKHTT.ngayRaQuyetDinh ? moment(checkInfoTTKHTT.ngayRaQuyetDinh).format('DD/MM/YYYY') : ''} />
                  <Text label={`Năm ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} className='col-20' value={`Kế hoạch ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} năm ${checkInfoTTKHTT && checkInfoTTKHTT.namThanhTra ? checkInfoTTKHTT.namThanhTra : ''}`} />
                </div>
                <div className='mt10'>
                  <div className='big-border'></div>
                </div>
                <section className='wrap-block'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-14 p20'>{`2. Thông tin bổ sung cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
                  </div>
                  <div className='row pl30 pr30'>
                    <Input className="col-25 mb10" label="Số công văn" placeholder="Nhập..." value={this.state.soCongVanBoSungCTT} onChange={this.onChange.bind(this, 'soCongVanBoSungCTT')} name='soCongVanBoSungCTT' bindValidator={this} channel='formTaoDon' require />
                    <DatePicker className="col-25 mb10" label="Ngày quyết định" value={this.state.ngayQuyetDinhBoSungCTT} onChange={this.handleChangeDate.bind(this, 'ngayQuyetDinhBoSungCTT')} name='ngayQuyetDinhBoSungCTT' bindValidator={this} channel='formTaoDon' require />
                    <TextArea className="col-100 mb5" label="Lý do:" value={this.state.lyDoBoSungCTT} onChange={this.onChange.bind(this, 'lyDoBoSungCTT')} name='lyDoBoSungCTT' bindValidator={this} channel='formTaoDon' require maxLength={1000} />
                  </div>
                  <ShowIf condition={Data.showFileGiaHan}>
                    <div className='row pl35 pr35'>
                      <ContainerFileDinhKem ref='containerFileDinhKem' name='fileDinhKemDon' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuBoSungCTT} disableTopLine={true} phanLoaiQuyTrinh="BO_SUNG_CUOC_THANH_TRA" onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChangeDK.bind(this)} />
                    </div>
                  </ShowIf>
                </section>
              </ShowIf>
              <div className='mt10'>
                <div className='big-border'></div>
              </div>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>{checkLayoutBoSung === true ? `3. Thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}` : `1. Thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
              </div>
              <div className='row pl30 pr30'>
                {/* <DropDownMulipleUse label='Năm thanh tra' className='col-25' data={this.state.dataNamThanhTra} selectedValue={this.state.namThanhTra} onChange={this.onChange.bind(this, 'namThanhTra')} name='namThanhTra' keyName='giaTri' valueName='ten' require bindValidator={this} channel="formTaoDon"/> */}
                <div className='row pl15 pr15'>
                  <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'doiTuongThanhTras')}>
                    <div>
                      <div className='wrap-input-tt-dvph col-25 mrt22'>
                        <Link className="col-100 no-gutter btn-green btn-pullleft" onClick={this.openDialogThanhTra.bind(this)}><i className="tt tt-addfile"></i>Đối tượng {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}</Link>
                      </div>
                      {/* {
                        this.state.cuocThanhTraNhieuDoiTuong === true &&
                        <div className='wrap-input-tt-dvph col-55 mrt22'>
                          <Input placeholder={`Tên đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}...`} value={this.state.tenNhieuDoiTuongThanhTra} onChange={this.onChange.bind(this, 'tenNhieuDoiTuongThanhTra')} name='tenNhieuDoiTuongThanhTra' className="col-55" require={true} bindValidator={this} channel="formTaoDon" />
                        </div>
                      } */}
                      <div className='col-100 mb18'>
                        <div className='ds-tt-dvph'>
                          {
                            this.state.doiTuongThanhTras.map((item, i) => (
                              <div className='tt-dvph-item' key={i}>
                                <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'doiTuongThanhTras', i)}>×</span>
                                <span className="tt-dvph-value">{item.ten}</span>
                              </div>
                            ))
                          }
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                <TextArea triggerOnblur={true} label={`Tên cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' value={this.state.ten} onChange={this.onChange.bind(this, 'ten')} name='ten' require bindValidator={this} channel="formTaoDon" maxLength={500} />
                <Input label={`Thời kỳ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} placeholder='Nhập...' className='col-25' value={this.state.kyThanhTra} onChange={this.onChange.bind(this, 'kyThanhTra')} name='kyThanhTra' require bindValidator={this} channel="formTaoDon" />
                <Text label={`Tiến độ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} className='col-25' value={Data.tienDoThanhTra} red={true} />
                <Checkbox className='col-25 pt-large pt-dvph' name="kyTruocChuyenSang" checked={this.state.kyTruocChuyenSang || false} onChange={this.changeCheckbox.bind(this)}>
                  <span className="span-checkbox span-position-label">Kỳ trước chuyển sang</span>
                </Checkbox>
                <TextArea triggerOnblur={true} label={`Nội dung ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' value={this.state.noiDungThanhTra} onChange={this.onChange.bind(this, 'noiDungThanhTra')} name='noiDungThanhTra' require bindValidator={this} channel="formTaoDon" maxLength={500} />
              </div>
              <div className='row pl30 pr30'>
                <Input label={`Số quyết định về việc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-25' value={this.state.soQuyetDinhVeViecThanhTra} onChange={this.onChange.bind(this, 'soQuyetDinhVeViecThanhTra')} name='soQuyetDinhVeViecThanhTra' require bindValidator={this} channel="formTaoDon" maxLength={255} />
                <DatePicker label='Ngày ra quyết định' className='col-25' value={this.state.ngayRaQuyetDinh} onChange={this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} name='ngayRaQuyetDinh' require bindValidator={this} channel="formTaoDon" endDate={new Date()} />
                {/* <DropDownMulipleUse label='Hình thức' className='col-25' data={this.state.dataHinhThucThanhTra} selectedValue={this.state.hinhThucThanhTra} onChange={this.onChange.bind(this, 'hinhThucThanhTra')} name='hinhThucThanhTra' keyName='giaTri' valueName='ten' /> */}
                <ShowIf condition={this.state.hinhThucThanhTra == 'DOT_XUAT'}>
                  <TextArea label={`Căn cứ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} đột xuất`} className='col-100' placeholder='Nhập...' value={this.state.canCuThanhTraDotXuat} onChange={this.onChange.bind(this, 'canCuThanhTraDotXuat')} name='canCuThanhTraDotXuat' maxLength={500} />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <DatePicker label={`Ngày công bố QĐ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-25' startDate={this.state.ngayRaQuyetDinh} value={this.state.ngayCongBoQuyetDinhThanhTra} onChange={this.handleChangeDate.bind(this, 'ngayCongBoQuyetDinhThanhTra')} name='ngayCongBoQuyetDinhThanhTra' require bindValidator={this} channel="formTaoDon" />
                <div className='wrap-thoihan col-25'>
                  <Input label={`Thời hạn ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} (ngày)`} type='sdt' className='col-100 no-gutter' value={this.state.thoiHanThanhTra} onChange={this.onChange.bind(this, 'thoiHanThanhTra')} name='thoiHanThanhTra' />
                  <span className='thoihan-value'>
                    <ShowIf condition={!this.state.getThoiHanThanhTra}>
                      <span>
                        {this.state.ngayHetHanThanhTra != 'Invalid date' ? this.state.ngayHetHanThanhTra : ''}
                      </span>
                    </ShowIf>
                    <ShowIf condition={this.state.getThoiHanThanhTra}>
                      <span className='icon-loader'></span>
                    </ShowIf>
                  </span>
                </div>

                <DropDownChonLoaiHinhThanhTra label='Loại hình' data={this.state.dataLoaiHinhThanhTra} className='col-25' selectedValue={this.state.loaiHinhThanhTra} onChange={this.onChange.bind(this, 'loaiHinhThanhTra')} name='loaiHinhThanhTra' />
                <ShowIf condition={this.state.loaiHinhThanhTra == 'THANH_TRA_LAI'}>
                  <DropDownChonCanCuThanhTraLai label={`Căn cứ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} lại`} data={this.state.dataThanhTraLai} className='col-25' selectedValue={this.state.canCuThanhTraLai} onChange={this.onChange.bind(this, 'canCuThanhTraLai')} name='canCuThanhTraLai' />
                </ShowIf>
              </div>
              <div className='row pl30 pr30'>
                <DropDownMulipleUse label={`Hoạt động ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} keyName='giaTri' confirm={true} placeholder={null} valueName='ten' className='col-25' data={this.state.dataChucNangCuocThanhTra} selectedValue={this.state.chucNangCuocThanhTra} onChange={this.onChange.bind(this, 'chucNangCuocThanhTra')} name='chucNangCuocThanhTra' />
                <ShowIf condition={Data.chucNangCuocThanhTra == 'HANH_CHINH'}>
                  <DropDownChonLinhVucThanhTraMultiple
                    label={`Lĩnh vực ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
                    confirm={true}
                    placeholder={null}
                    className='col-25'
                    data={this.state.dataLinhVucThanhTra.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    selectedValue={this.state.linhVucThanhTraList}
                    onChange={this.onChange.bind(this, 'linhVucThanhTraList')}
                    name='linhVucThanhTraList'
                    require
                    validLinhVucThanhTra={this.state.validLinhVucThanhTra}
                  />
                </ShowIf>
                <ShowIf condition={Data.chucNangCuocThanhTra == 'HANH_CHINH' && this.state.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM')}>
                  <DropDownMultipleSelect
                    label=" "
                    className='col-25 mt16'
                    bindValidator={this}
                    channel="formTaoDon"
                    value={this.state.thucHienPhapLuatVeThanhTraList}
                    options={this.state.thucHienPhapLuatVeThanhTraListCombobox.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    onChange={this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList')}
                    placeholder=''
                    closeMenuOnSelect={false}
                  />
                </ShowIf>
                <ShowIf condition={Data.chucNangCuocThanhTra == 'HANH_CHINH'}>
                  <Input
                    className="col-25"
                    label="Chi tiết lĩnh vực"
                    placeholder="Nhập..."
                    value={this.state.chiTietLinhVuc}
                    onChange={this.onChange.bind(this, 'chiTietLinhVuc')}
                    name='chiTietLinhVuc'
                    bindValidator={this}
                    channel='formTaoDon'
                    maxLength={255}
                  />
                </ShowIf>
                {
                  this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' &&
                  <DropDown className='col-25' label={`Hình thức ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} chuyên ngành`} placeholder options={this.state.hinhThucThanhTraChuyenNganhList} keyName="giaTri" valueName="ten" selectedValue={this.state.hinhThucThanhTraChuyenNganh} onChange={this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh')} name='hinhThucThanhTraChuyenNganh' bindValidator={this} channel='formTaoDon' require />
                }
              </div>
              {/* <div className='row pl30 pr30'>
                <DropDownTreeSelectOneElement label='Đơn vị chủ trì' className='col-25' dataOptions={this.state.dataDonViChuTri} value={this.state.donViChuTri} onChange={this.onChange.bind(this, 'donViChuTri')} name='donViChuTri' propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' require bindValidator={this} channel="formTaoDon"/>
              </div> */}
            </ShowIf>
            <ShowIf condition={this.state.type == 'KE_HOACH'}>
              <div className='row pl15 pr15'>
                <h2 className='title-14 p20'>{checkLayout === true ? `3. Thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}` : `2. Thông tin cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
              </div>
              <div className='row pl30 pr30'>
                {
                  this.state.namThanhTra &&
                  <div className='row pl15 pr15'>
                    <form className='wrap-tt-dvph col-100 no-gutter' onSubmit={this.addDonVi.bind(this, 'doiTuongThanhTras')}>
                      <div>
                        <div className='wrap-input-tt-dvph col-20 mrt22'>
                          <Link className="col-100 no-gutter btn-green btn-pullleft" onClick={this.openDialogThanhTra.bind(this)}><i className="tt tt-addfile"></i>Đối tượng {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}</Link>
                        </div>
                        {/* {
                          this.state.cuocThanhTraNhieuDoiTuong === true &&
                          <div className='wrap-input-tt-dvph col-25 mrt22'>
                            <Input placeholder={`Tên đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}...`} value={this.state.tenNhieuDoiTuongThanhTra} onChange={this.onChange.bind(this, 'tenNhieuDoiTuongThanhTra')} name='tenNhieuDoiTuongThanhTra' className="col-100" require={true} bindValidator={this} channel="formTaoDon" />
                          </div>
                        } */}
                        <div className='col-100 mb18'>
                          <div className='ds-tt-dvph'>
                            {
                              this.state.doiTuongThanhTras.map((item, i) => (
                                <div className='tt-dvph-item' key={i}>
                                  <span className="tt-dvph-icon" onClick={this.removeDonVi.bind(this, 'doiTuongThanhTras', i)}>×</span>
                                  <span className="tt-dvph-value">{item.ten}</span>
                                </div>
                              ))
                            }
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                }
                <div className="col-25 mb15">
                  <label className="pt-label">
                    <span className="val-title-bold">{`Đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`}</span>
                    <span className="val-content txt-blue txt-underline cursor-pointer txt-inline-block" onClick={this.showDoiTuongThanhTra.bind(this)}>{DataDetail && DataDetail.listDoiTuongThanhTra && DataDetail.listDoiTuongThanhTra.length > 0 && !DataDetail.tenNhieuDoiTuongThanhTra ? DataDetail.listDoiTuongThanhTra[0].ten : DataDetail.tenNhieuDoiTuongThanhTra}</span>
                  </label>
                </div>
                <Text label={`Thời kỳ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} className='col-25 mb15' value={Data.kyThanhTra ? Data.kyThanhTra : ''} />
                <Text label={`Tiến độ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} className='col-25 mb15' value={showTienDoThanhTra} red={true} />
                <div className='col-25 mb15'>
                  <Checkbox className='pt-large pt-dvph' name="kyTruocChuyenSang" checked={this.state.kyTruocChuyenSang || false} onChange={this.changeCheckbox.bind(this)}>
                    <span className="span-checkbox span-position-label">Kỳ trước chuyển sang</span>
                  </Checkbox>
                </div>
                <TextArea triggerOnblur={true} label={`Tên cuộc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' value={this.state.ten} onChange={this.onChange.bind(this, 'ten')} name='ten' require bindValidator={this} channel="formTaoDon" maxLength={500} />
                <TextArea label={`Nội dung ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}:`} className='col-100 mb15' value={Data.noiDungThanhTra ? Data.noiDungThanhTra : ''} onChange={this.onChange.bind(this, 'noiDungThanhTra')} name='noiDungThanhTra' require bindValidator={this} channel="formTaoDon" maxLength={500} />
              </div>
            </ShowIf>
          </section>
          <section className='wrap-block mb10'>
            <ShowIf condition={this.state.type == 'KE_HOACH'}>
              <div className='row pl30 pr30'>
                <Input label={`Số quyết định về việc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-25' value={this.state.soQuyetDinhVeViecThanhTra} onChange={this.onChange.bind(this, 'soQuyetDinhVeViecThanhTra')} name='soQuyetDinhVeViecThanhTra' require bindValidator={this} channel="formTaoDon" maxLength={255} />
                <DatePicker label='Ngày ra quyết định' className='col-25' value={this.state.ngayRaQuyetDinh} endDate={new Date()} onChange={this.handleChangeDate.bind(this, 'ngayRaQuyetDinh')} name='ngayRaQuyetDinh' require bindValidator={this} channel="formTaoDon" />
                <DatePicker label={`Ngày công bố QĐ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-25' value={this.state.ngayCongBoQuyetDinhThanhTra} startDate={this.state.ngayRaQuyetDinh} onChange={this.handleChangeDate.bind(this, 'ngayCongBoQuyetDinhThanhTra')} name='ngayCongBoQuyetDinhThanhTra' require bindValidator={this} channel="formTaoDon" />
                <div className='wrap-thoihan col-25'>
                  <Input label={`Thời hạn ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} (ngày)`} type='sdt' className='col-100 no-gutter' value={this.state.thoiHanThanhTra} onChange={this.onChange.bind(this, 'thoiHanThanhTra')} name='thoiHanThanhTra' />
                  <span className='thoihan-value'>
                    <ShowIf condition={!this.state.getThoiHanThanhTra}>
                      <span>
                        {this.state.ngayHetHanThanhTra != 'Invalid date' ? this.state.ngayHetHanThanhTra : ''}
                      </span>
                    </ShowIf>
                    <ShowIf condition={this.state.getThoiHanThanhTra}>
                      <span className='icon-loader'></span>
                    </ShowIf>
                  </span>
                </div>
              </div>
            </ShowIf>
            <div className='row pl30 pr30'>
              <ShowIf condition={this.state.type == 'KE_HOACH'}>
                <DropDownMulipleUse label={`Hoạt động ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} keyName='giaTri' confirm={true} placeholder={null} valueName='ten' className='col-25' data={this.state.dataChucNangCuocThanhTra} selectedValue={this.state.chucNangCuocThanhTra} onChange={this.onChange.bind(this, 'chucNangCuocThanhTra')} name='chucNangCuocThanhTra' />
                {
                  this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ?
                    <DropDown className='col-25' label={`Hình thức ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} chuyên ngành`} placeholder options={this.state.hinhThucThanhTraChuyenNganhList} keyName="giaTri" valueName="ten" selectedValue={this.state.hinhThucThanhTraChuyenNganh} onChange={this.onChange.bind(this, 'hinhThucThanhTraChuyenNganh')} name='hinhThucThanhTraChuyenNganh' bindValidator={this} channel='formTaoDon' require />
                    :
                    <DropDownChonLinhVucThanhTraMultiple
                      label={`Lĩnh vực ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
                      confirm={true}
                      placeholder={null}
                      className='col-25'
                      data={this.state.dataLinhVucThanhTra.map(item => ({
                        label: item.ten,
                        value: item.giaTri
                      }))}
                      selectedValue={this.state.linhVucThanhTraList}
                      onChange={this.onChange.bind(this, 'linhVucThanhTraList')}
                      name='linhVucThanhTraList'
                      require
                      validLinhVucThanhTra={this.state.validLinhVucThanhTra}
                    />
                }
                <ShowIf condition={Data.chucNangCuocThanhTra == 'HANH_CHINH' && this.state.linhVucThanhTraList.includes('THANH_TRA_TRACH_NHIEM')}>
                  <DropDownMultipleSelect
                    className='col-25 mt16'
                    bindValidator={this}
                    channel="formTaoDon"
                    value={this.state.thucHienPhapLuatVeThanhTraList}
                    options={this.state.thucHienPhapLuatVeThanhTraListCombobox.map(item => ({
                      label: item.ten,
                      value: item.giaTri
                    }))}
                    onChange={this.onChange.bind(this, 'thucHienPhapLuatVeThanhTraList')}
                    placeholder=''
                    closeMenuOnSelect={false}
                  />
                </ShowIf>
                <ShowIf condition={Data.chucNangCuocThanhTra == 'HANH_CHINH'}>
                  <Input
                    className="col-25"
                    label="Chi tiết lĩnh vực"
                    placeholder="Nhập..."
                    value={this.state.chiTietLinhVuc}
                    onChange={this.onChange.bind(this, 'chiTietLinhVuc')}
                    name='chiTietLinhVuc'
                    bindValidator={this}
                    channel='formTaoDon'
                    maxLength={255}
                  />
                </ShowIf>
                <ShowIf condition={this.state.hinhThucThanhTra == 'DOT_XUAT'}>
                  <TextArea label={`Căn cứ ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} đột xuất`} className='col-100' placeholder='Nhập...' value={this.state.canCuThanhTraDotXuat} onChange={this.onChange.bind(this, 'canCuThanhTraDotXuat')} name='canCuThanhTraDotXuat' maxLength={500} />
                </ShowIf>
                {/* <DropDownTreeSelectOneElement label='Đơn vị chủ trì' className='col-25' dataOptions={this.state.dataDonViChuTri} value={this.state.donViChuTri} onChange={this.onChange.bind(this, 'donViChuTri')} name='donViChuTri' propertyChildren='coQuanQuanLyCha' propertyParent='coQuanQuanLyId' require bindValidator={this} channel="formTaoDon"/> */}
              </ShowIf>
              {/* <InputList label='Đơn vị phối hợp' data={this.state.dataDonViPhoiHop} onChange={this.onChange.bind(this, 'donViPhoiHop')} name='donViPhoiHop' countUnit='đơn vị' hasCount={true}/> */}
              <InputList
                onRef={doiTuongThanhTraLienQuan => (this.doiTuongThanhTraLienQuan = doiTuongThanhTraLienQuan)}
                confirm={true}
                handleConfirm={this.handleConfirmDoiTuongLienQuan.bind(this)}
                label="Cơ quan đơn vị có liên quan"
                data={this.state.dataDoiTuongThanhTraLienQuan}
                onChange={this.onChange.bind(this, 'doiTuongThanhTraLienQuan')}
                name='doiTuongThanhTraLienQuan'
                countUnit='đối tượng'
                hasCount={true}
              />
              <ShowIf condition={Data.showFile}>
                <div className='col-100'>
                  <ContainerFileDinhKem name='tienHanh' label="Danh sách văn bản xử lý" phanLoaiQuyTrinh='THONG_TIN_CUOC_THANH_TRA' bindValidator={this} data={this.state.listTaiLieuVanThuThongTinCuocThanhTra} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                </div>
              </ShowIf>
            </div>
          </section>
          {/*end thông tin cuộc thanh tra*/}
          <section className="wrap-block">
            <div className="row pl10 pr10 heading-addnew-dttt">
              <h2 className="title-13 col-100 pl20 pr20 mt10">
                1.1 Căn cứ cuộc {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}
              </h2>
            </div>
            <div className="row pl10 pr10 ">
              <DataTable
                header={header.dsCanCuCuocThanhTra}
                dataList={this.state.danhMucVanBanCanCu}
                hidePagination={true}
                parent={this}
                addNewVanBanCanCu={this.addNewVanBanCanCu.bind(this)}
                isTableCanCuCuocThanhTra
              >
                <RowItemCanCuCuocThanhTra listDanhMucVanBan={this.state.listDanhMucVanBan} onChange={this.onChangeTenVanBan.bind(this)} removeVanBanCanCu={this.removeVanBanCanCu.bind(this)} />
              </DataTable>
            </div>
          </section>
          <div>
            <div className='pl20 pb20 pr20'>
              <div className='line-border'></div>
            </div>
            {/*Thành viên đoàn*/}
            <ShowIf condition={Data.chucNangCuocThanhTra == 'CHUYEN_NGANH'}>
              <div>
                <section className='wrap-block pl20 pr20 mb10'>
                  <ShowIfCheck titleClass='title-12 lable-title-custom' className='row pl15 pr15' label={this.state.type == 'KE_HOACH' ? "2.1 Thành viên đoàn" : '1.1 Thành viên đoàn'} onChange={this.handleCheck.bind(this, 'thanhVienDoan')} name='thanhVienDoan' checked={this.state.thanhVienDoan}>
                    <div className='col-100 no-gutter'>
                      <div className='row pl10 pr10 mb10'>
                        <Input label='Số quyết định' placeholder='Nhập...' className='col-25 mb0-18' require bindValidator={this} channel="formTaoDon" value={this.state.soQuyetDinhThanhLapDoan} onChange={this.onChange.bind(this, 'soQuyetDinhThanhLapDoan')} name='soQuyetDinhThanhLapDoan' maxLength={255} />
                        <DatePicker label='Ngày quyết định' className='col-25 mb0-18' value={this.state.ngayRaQuyetDinhThanhLapDoan} onChange={this.handleChangeDate.bind(this, 'ngayRaQuyetDinhThanhLapDoan')} name='ngayRaQuyetDinhThanhLapDoan' require bindValidator={this} channel="formTaoDon" />
                      </div>
                      <ShowIf condition={Data.showFile}>
                        <div className='wrap-table-show-oncheck white-table'>
                          <DataTableAttachElement addItem={this.addItem.bind(this)} header={header.thanhTra.TMTVCTT} dataList={this.state.thanhVienDoans} hideButtonExport={true} hidePagination={true} pageData={this.state.pageData} parent={this} search={this.state.search}
                            tableLoading={this.state.tableLoading}>
                            <RowItemChiTietThanhVienCuocThanhTra dataVaiTroThanhVienDoan={this.state.dataVaiTroThanhVienDoan} onItemRemove={this.onItemRemove.bind(this)} onItemChange={this.onItemChange.bind(this)} />
                          </DataTableAttachElement>
                        </div>
                      </ShowIf>
                    </div>
                  </ShowIfCheck>
                </section>
                <div className='pl20 pb20 pr20'>
                  <div className='line-border'></div>
                </div>
              </div>
            </ShowIf>
            {/*end Thành viên đoàn*/}
            {/*Gia hạn*/}
            <ShowIf condition={checkLayout !== true && checkLayoutBoSung !== true}>
              <ShowIfCheck titleClass='title-12 lable-title-custom' className='pl35 pr35 mb10 row pt20' onChange={this.handleCheck.bind(this, 'coQuyetDinhGiamSat')} name='coQuyetDinhGiamSat' checked={this.state.coQuyetDinhGiamSat} label={this.state.type == 'KE_HOACH' ? (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? `2.4. Quyết định giám sát` : `2.3. Quyết định giám sát`) : (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? `1.4. Quyết định giám sát` : `1.2. Quyết định giám sát`)}>
                <div>
                  <ShowIf condition={this.state.showFile}>
                    <div>
                      <ContainerFileDinhKem hidenTopTitle name='quyetDinhGiamSat' loaiVanBanSuggest='THEO_DOI_THUC_HIEN_SAU_THANH_TRA' soVanBanSuggest={this.state.soVanBanQuyetDinhGiamSat} ngayQuyetDinhSuggest={this.state.ngayBanHanhQuyetDinhGiamSat} phanLoaiQuyTrinh='QUYET_DINH_GIAM_SAT' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuQuyetDinhGiamSat} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                    </div>
                  </ShowIf>
                </div>
              </ShowIfCheck>
              <ShowIfCheck titleClass='title-12 lable-title-custom' className='pl35 pr35 mb10 row' onChange={this.handleCheck.bind(this, 'giaHan')} name='giaHan' checked={this.state.giaHan} label={this.state.type == 'KE_HOACH' ? (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '2.2 Gia hạn' : '2.1 Gia hạn') : (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? '1.3 Gia hạn' : '1.3 Gia hạn')}>
                <section className='wrap-block '>
                  <div className='row pl10 pr10'>
                    <Input className="col-25 mb10" label="Số quyết định" placeholder="Nhập..." value={this.state.soQuyetDinhGiaHan} onChange={this.onChange.bind(this, 'soQuyetDinhGiaHan')} name='soQuyetDinhGiaHan' bindValidator={this} channel='formTaoDon' require maxLength={255} />
                    <DatePicker className="col-25 mb10" label="Ngày ra quyết định" value={this.state.ngayRaQuyetDinhGiaHan} onChange={this.handleChangeDate.bind(this, 'ngayRaQuyetDinhGiaHan')} name='ngayRaQuyetDinhGiaHan' bindValidator={this} channel='formTaoDon' require endDate={new Date()} />
                    <TextArea className="col-100 mb5" label="Lý do gia hạn:" value={this.state.lyDonGiaHan} onChange={this.onChange.bind(this, 'lyDonGiaHan')} name='lyDonGiaHan' maxLength={1000} />
                  </div>
                  <ShowIf condition={Data.showFileGiaHan}>
                    <div className='col-100 no-gutter'>
                      <ContainerFileDinhKem name='giaHan' loaiVanBanSuggest='TT_GIA_HAN' soVanBanSuggest={this.state.soQuyetDinhGiaHan} ngayQuyetDinhSuggest={this.state.ngayRaQuyetDinhGiaHan} phanLoaiQuyTrinh='GIA_HAN' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuGiaHan} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                    </div>
                  </ShowIf>
                </section>
              </ShowIfCheck>
            </ShowIf>
            {/*end Gia hạn*/}
          </div>

          <ShowIf condition={(this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' || this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN') && userInfo.capCoQuanQuanLyId !== TTTrungUong}>
            <div>
              <div className='pl20 pr20'>
                <div className='line-border'></div>
              </div>
              <div className='row pl15 pr15'>
                <h2 className='title-12 p20'>{this.state.type == 'KE_HOACH' ? (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? `2.3. Thông báo kết thúc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} trực tiếp` : `2.2. Thông báo kết thúc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} trực tiếp`) : (this.state.chucNangCuocThanhTra == 'CHUYEN_NGANH' ? `1.3. Thông báo kết thúc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} trực tiếp` : `1.2. Thông báo kết thúc ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} trực tiếp`)}</h2>
              </div>
              <div className='row pl30 pr30'>
                <div className='col-100 no-gutter'>
                  <Input require bindValidator={this} triggeOnBlur={true} channel="formTaoDon" label='Số thông báo' placeholder='Nhập...' className='col-25' value={this.state.soThongBaoKetThucTTTT} onChange={this.onChange.bind(this, 'soThongBaoKetThucTTTT')} name='soThongBaoKetThucTTTT' maxLength={255} />
                  <DatePicker require bindValidator={this} triggeOnBlur={true} endDate={new Date()} channel="formTaoDon" label='Ngày ban hành' className='col-25' value={this.state.ngayBanHanhThongBaoKetThucTTTT} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhThongBaoKetThucTTTT')} name='ngayBanHanhThongBaoKetThucTTTT' />
                </div>
                <TextArea label='Ghi chú' className='col-100' placeholder='Nhập...' value={this.state.ghiChu} onChange={this.onChange.bind(this, 'ghiChu')} name='ghiChu' maxLength={1000} />
              </div>
              <ShowIf condition={this.state.showFile}>
                <div className='pl20 pr20'>
                  <ContainerFileDinhKem name='ketThucTTTT' loaiVanBanSuggest='TT_THONG_BAO_KT_TTTT' soVanBanSuggest={this.state.soThongBaoKetThucTTTT} ngayQuyetDinhSuggest={this.state.ngayBanHanhThongBaoKetThucTTTT} phanLoaiQuyTrinh='THONG_BAO_KET_THUC_THANH_TRA_TRUC_TIEP' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuThongBaoKetThucTTTT} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                </div>
              </ShowIf>
            </div>
          </ShowIf>

          {/* <ShowIf condition={(this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' || this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN') && userInfo.capCoQuanQuanLyId !== TTTrungUong}>

          </ShowIf> */}

          <ShowIf condition={this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN' || (this.checkIsKiemTra() && this.state.tienDoThanhTraType == 'DANG_TIEN_HANH')}>
            <div>
              <div className='big-border'></div>
              {/* Kết luận thanh tra trung ương */}
              {
                userInfo.capCoQuanQuanLyId === TTTrungUong &&
                <section className='wrap-block pb10'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-14 p20'>{this.state.type === 'KE_HOACH' ? `3. Kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} rút gọn` : `2. Kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} rút gọn`}</h2>
                  </div>
                  <div className='row pl30 pr30'>
                    <div className='col-100 no-gutter'>
                      <DropDown require bindValidator={this} channel="formTaoDon" className='col-25' label='Trạng thái' selectedValue={this.state.trangThaiRutGon} onChange={this.onChange.bind(this, 'trangThaiRutGon')} name='trangThaiRutGon' placeholder options={this.state.listtrangThaiRutGon} keyName="giaTri" valueName="ten" />
                      <DatePicker require bindValidator={this} triggeOnBlur={true} endDate={new Date()} channel="formTaoDon" label='Ngày thực hiện' className='col-25' value={this.state.ngayThucHien} onChange={this.handleChangeDate.bind(this, 'ngayThucHien')} name='ngayThucHien' />
                    </div>
                  </div>
                  <div className='row pl35 pr35'>
                    <div className='col-100 no-gutter'>
                      <ContainerFileDinhKem disableTopLine onSave={this.state.onSave} label="Văn bản đính kèm" bindValidator={this} data={this.state.listTaiLieuKetLuanThanhTraRutGon} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} phanLoaiQuyTrinh='KET_LUAN_THANH_TRA_RUT_GON' />
                    </div>
                  </div>
                  <div className='pl15 pr15'>
                    <div className='line-border'></div>
                  </div>
                  <ShowIfCheck titleClass='title-14 lable-title-custom' className='pl35 pr35 mb10 row pt20' onChange={this.handleCheck.bind(this, 'ketLuanThanhTra')} name='ketLuanThanhTra' checked={this.state.ketLuanThanhTra} label={this.state.type === 'KE_HOACH' ? '3.1 Kết luận thanh tra đầy đủ' : '2.1 Kết luận thanh tra đầy đủ'}>
                    <div className='row pl10 pr10'>
                      <div className='col-100 no-gutter'>
                        <Input require bindValidator={this} triggeOnBlur={true} channel="formTaoDon" label='Số kết luận thanh tra' placeholder='Nhập...' className='col-25' value={this.state.soKetLuanThanhTra} onChange={this.onChange.bind(this, 'soKetLuanThanhTra')} name='soKetLuanThanhTra' maxLength={255} />
                        <DatePicker require bindValidator={this} triggeOnBlur={true} endDate={new Date()} channel="formTaoDon" label='Ngày ban hành' className='col-25' value={this.state.ngayBanHanhKetLuanThanhTra} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhKetLuanThanhTra')} name='ngayBanHanhKetLuanThanhTra' />
                        <DropDownMulipleUse
                          label='Đơn vị ban hành'
                          className='col-25'
                          selectedValue={this.state.donViBanHanh}
                          onChange={this.onChange.bind(this, 'donViBanHanh')}
                          name='donViBanHanh'
                          data={this.state.dataDonViBanHanh}
                          keyName='giaTri'
                          valueName='ten'
                        />
                      </div>
                      <div className='col-100 no-gutter'>
                        <Input bindValidator={this} channel="formTaoDon" label='Số quyết định xử lý' placeholder='Nhập...' className='col-25' value={this.state.soQuyetDinhXuLy} onChange={this.onChange.bind(this, 'soQuyetDinhXuLy')} name='soQuyetDinhXuLy' maxLength={255} />
                        <DatePicker bindValidator={this} channel="formTaoDon" endDate={new Date()} label='Ngày ban hành' className='col-25' value={this.state.ngayBanHanhQuyetDinhXuLy} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhQuyetDinhXuLy')} name='ngayBanHanhQuyetDinhXuLy' />
                      </div>
                      <TextArea label={`Tóm tắt kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' placeholder='Nhập...' value={this.state.tomTatKetLuanThanhTra} onChange={this.onChange.bind(this, 'tomTatKetLuanThanhTra')} name='tomTatKetLuanThanhTra' maxLength={1000} />
                    </div>
                    <ShowIf condition={this.state.showFile}>
                      <div>
                        <ContainerFileDinhKem loaiVanBanSuggest='TT_KET_LUAN_THANH_TRA' soVanBanSuggest={this.state.soKetLuanThanhTra} ngayQuyetDinhSuggest={this.state.ngayBanHanhKetLuanThanhTra} name='ketLuanTranhTra' phanLoaiQuyTrinh='KET_LUAN_THANH_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuKetLuanThanhTra} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                      </div>
                    </ShowIf>
                  </ShowIfCheck>
                </section>
              }
              {/* END Kết luận thanh tra trung ương */}
              {
                userInfo.capCoQuanQuanLyId !== TTTrungUong &&
                <section className='wrap-block pb10'>
                  <div className='row pl15 pr15'>
                    <h2 className='title-14 p20'>{this.state.type === 'KE_HOACH' ? `3. Kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}` : `2. Kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}</h2>
                  </div>
                  <div className='row pl30 pr30'>
                    <div className='col-100 no-gutter'>
                      <Input require bindValidator={this} triggeOnBlur={true} channel="formTaoDon" label={`Số kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} placeholder='Nhập...' className='col-25' value={this.state.soKetLuanThanhTra} onChange={this.onChange.bind(this, 'soKetLuanThanhTra')} name='soKetLuanThanhTra' maxLength={255} />
                      <DatePicker require bindValidator={this} triggeOnBlur={true} endDate={new Date()} channel="formTaoDon" label='Ngày ban hành' className='col-25' value={this.state.ngayBanHanhKetLuanThanhTra} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhKetLuanThanhTra')} name='ngayBanHanhKetLuanThanhTra' />
                      <DropDownMulipleUse
                        label='Đơn vị ban hành'
                        className='col-25'
                        selectedValue={this.state.donViBanHanh}
                        onChange={this.onChange.bind(this, 'donViBanHanh')}
                        name='donViBanHanh'
                        data={this.state.dataDonViBanHanh}
                        keyName='giaTri'
                        valueName='ten'
                      />
                    </div>
                    <div className='col-100 no-gutter'>
                      <Input bindValidator={this} channel="formTaoDon" label='Số quyết định xử lý' placeholder='Nhập...' className='col-25' value={this.state.soQuyetDinhXuLy} onChange={this.onChange.bind(this, 'soQuyetDinhXuLy')} name='soQuyetDinhXuLy' maxLength={255} />
                      <DatePicker bindValidator={this} channel="formTaoDon" endDate={new Date()} label='Ngày ban hành' className='col-25' value={this.state.ngayBanHanhQuyetDinhXuLy} onChange={this.handleChangeDate.bind(this, 'ngayBanHanhQuyetDinhXuLy')} name='ngayBanHanhQuyetDinhXuLy' />
                    </div>
                    <TextArea label={`Tóm tắt kết luận ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`} className='col-100' placeholder='Nhập...' value={this.state.tomTatKetLuanThanhTra} onChange={this.onChange.bind(this, 'tomTatKetLuanThanhTra')} name='tomTatKetLuanThanhTra' maxLength={1000} />
                  </div>
                  <ShowIf condition={this.state.showFile}>
                    <div className='pl20 pr20'>
                      <ContainerFileDinhKem loaiVanBanSuggest='TT_KET_LUAN_THANH_TRA' soVanBanSuggest={this.state.soKetLuanThanhTra} ngayQuyetDinhSuggest={this.state.ngayBanHanhKetLuanThanhTra} name='ketLuanTranhTra' phanLoaiQuyTrinh='KET_LUAN_THANH_TRA' label="Danh sách văn bản xử lý" bindValidator={this} data={this.state.listTaiLieuVanThuKetLuanThanhTra} disableTopLine={true} onFileRemove={this.onFileRemove.bind(this)} onFileChange={this.onFileChange.bind(this)} />
                    </div>
                  </ShowIf>
                </section>
              }
              <div className='big-border'></div>
              <ShowIfCheck titleClass='title-14 lable-title-custom' className='pl35 pr35 mb10 row pt20' onChange={this.handleCheck.bind(this, 'noiDungKienNghi')} name='noiDungKienNghi' checked={this.state.noiDungKienNghi} label={this.state.type == 'KE_HOACH' ? '4. Nội dung kiến nghị' : '3. Nội dung kiến nghị'}>
                <section className='wrap-block pb10'>
                  <div className='row pl15 pr15'>
                    <NoiDungKienNghi doiTuongThanhTraLienQuan={this.state.doiTuongThanhTraLienQuan} handleChangeData={this.handleChangeData.bind(this)} setDoiTuongViPhamHienTai={this.setDoiTuongViPhamHienTai.bind(this)} onRef={noiDungKienNghi => (this.noiDungKienNghi = noiDungKienNghi)} setCountDoiTuongViPham={this.setCountDoiTuongViPham.bind(this)} type={this.state.type} dataDoiTuongViPham={this.state.dataDoiTuongViPham} chucNangCuocThanhTra={this.state.chucNangCuocThanhTra} id={this.state.id} listDoiTuongViPham={this.state.listDoiTuongViPham} linhVucThanhTra={this.state.linhVucThanhTraList} />
                  </div>
                </section>
              </ShowIfCheck>
              <div className='pb20'>
                <div className='big-border'></div>
              </div>
              <section className='wrap-block pl20 pr20 pb10'>
                <ShowIfCheck titleClass='title-14 lable-title-custom' className='row pl15 pr15' label={this.state.type == 'KE_HOACH' ? '5. Nội dung tham nhũng' : '4. Nội dung tham nhũng'} onChange={this.handleCheck.bind(this, 'noiDungThamNhung')} name='noiDungThamNhung' checked={this.state.noiDungThamNhung}>
                  <div className='col-100 no-gutter'>
                    <div className="row pl10 pr10">
                      <InputNumber className="col-25" label="Số vụ" require bindValidator={this} channel="formTaoDon" value={this.state.soVuThamNhung} onChange={this.onChange.bind(this, 'soVuThamNhung')} name='soVuThamNhung' />
                      <InputNumber className="col-25" label="Số đối tượng" require bindValidator={this} channel="formTaoDon" value={this.state.soDoiTuongThamNhung} onChange={this.onChange.bind(this, 'soDoiTuongThamNhung')} name='soDoiTuongThamNhung' maxLength={255} />
                      <div className="col-100 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Tài sản tham nhũng</p>
                        <Input className="col-25" type="sdt" align="right" label="Tiền (Trđ)" value={this.state.tienThamNhung} onChange={this.onChange.bind(this, 'tienThamNhung')} name='tienThamNhung' />
                        <Input className="col-25" type="sdt" align="right" label="Tài sản khác (Trđ)" value={this.state.taiSanKhacThamNhung} onChange={this.onChange.bind(this, 'taiSanKhacThamNhung')} name='taiSanKhacThamNhung' />
                        <Input className="col-25" type="sdt" align="right" label="Đất (m2)" value={this.state.datThamNhung} onChange={this.onChange.bind(this, 'datThamNhung')} name='datThamNhung' />
                      </div>
                      <div className="col-100 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị thu hồi</p>
                        <Input className="col-25" type="sdt" align="right" label="Tiền (Trđ)" value={this.state.tienKienNghiThuHoi} onChange={this.onChange.bind(this, 'tienKienNghiThuHoi')} name='tienKienNghiThuHoi' />
                        <Input className="col-25" type="sdt" align="right" label="Tài sản khác (Trđ)" value={this.state.taiSanKhacKienNghiThuHoi} onChange={this.onChange.bind(this, 'taiSanKhacKienNghiThuHoi')} name='taiSanKhacKienNghiThuHoi' />
                        <Input className="col-25" type="sdt" align="right" label="Đất (m2)" value={this.state.datKienNghiThuHoi} onChange={this.onChange.bind(this, 'datKienNghiThuHoi')} name='datKienNghiThuHoi' />
                      </div>
                      <div className="col-100 no-gutter clear-left">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Đã thu</p>
                        <Input className="col-25" type="sdt" align="right" label="Tiền (Trđ)" value={this.state.tienDaThu} onChange={this.onChange.bind(this, 'tienDaThu')} name='tienDaThu' />
                        <Input className="col-25" type="sdt" align="right" label="Tài sản khác (Trđ)" value={this.state.taiSanKhacDaThu} onChange={this.onChange.bind(this, 'taiSanKhacDaThu')} name='taiSanKhacDaThu' />
                        <Input className="col-25" type="sdt" align="right" label="Đất (m2)" value={this.state.datDaThu} onChange={this.onChange.bind(this, 'datDaThu')} name='datDaThu' />
                      </div>
                      <div className="col-50 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý hành chính</p>
                        <InputNumber className="col-50" label="Tổ chức" value={this.state.toChucXuLyHanhChinhThamNhung} onChange={this.onChange.bind(this, 'toChucXuLyHanhChinhThamNhung')} name='toChucXuLyHanhChinhThamNhung' />
                        <InputNumber className="col-50" label="Cá nhân" value={this.state.caNhanXuLyHanhChinhThamNhung} onChange={this.onChange.bind(this, 'caNhanXuLyHanhChinhThamNhung')} name='caNhanXuLyHanhChinhThamNhung' />
                      </div>
                      <div className="col-50 no-gutter">
                        <p className="txt-bold txt-upper mb10 pl5 pr5">Xử lý trách nhiệm người đứng đầu</p>
                        <InputNumber className="col-50" label="Số người" value={this.state.soNguoiXuLyTrachNhiemDungDau} onChange={this.onChange.bind(this, 'soNguoiXuLyTrachNhiemDungDau')} name='soNguoiXuLyTrachNhiemDungDau' />
                        <Input className="col-50" label="Tên người" placeholder='Nhập...' value={this.state.tenNguoi} onChange={this.onChange.bind(this, 'tenNguoi')} name='tenNguoi' maxLength={255} />
                      </div>
                    </div>
                  </div>
                </ShowIfCheck>
              </section>
            </div>
          </ShowIf>
        </div>
        <ShowIf condition={this.state.getDetail === true}>
          <div className="action-form-wrap pl0 pr0 pt35 pb5">
            <div className="box-bottom">
              <Link className="btn-action btn-close" onClick={this.handleBack.bind(this, false, 'close')}><span>Đóng</span></Link>
              <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-save action-todo btn-loading-inline" : 'btn-action btn-save action-todo btn-disable') : "btn-action btn-save action-todo"} onClick={this.handleSave.bind(this)}><span>Lưu tạm</span></Link>
              <ShowIf condition={this.state.tienDoThanhTraType != 'DANG_TIEN_HANH' && this.state.tienDoThanhTraType != 'KET_THUC_THANH_TRA_TRUC_TIEP' && this.state.tienDoThanhTraType != 'DA_BAN_HANH_KET_LUAN'}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.postProcess.bind(this)}><span>Tiến hành {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}</span></Link>
              </ShowIf>
              <ShowIf condition={(this.state.tienDoThanhTraType == 'DANG_TIEN_HANH') && !this.checkIsKiemTra()}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.postProcess.bind(this)}><span>Kết thúc {this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'} trực tiếp</span></Link>
              </ShowIf>
              <ShowIf condition={(this.state.tienDoThanhTraType == 'KET_THUC_THANH_TRA_TRUC_TIEP' || this.state.tienDoThanhTraType == 'DA_BAN_HANH_KET_LUAN') && !this.checkIsKiemTra()}>
                {
                  (this.state.noiDungKienNghi === true) && (userInfo.capCoQuanQuanLyId !== TTTrungUong) && !this.checkIsKiemTra() ? (
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this)}><span>Chuyển theo dõi thực hiện</span></Link>
                  ) : (
                    <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this)}><span>Lưu hồ sơ</span></Link>
                  )
                }

              </ShowIf>
              <ShowIf condition={this.state.tienDoThanhTraType == 'DANG_TIEN_HANH' && this.checkIsKiemTra()}>
                <Link className={this.state.btnLoading ? (this.state.btnSaveLoading ? "btn-action btn-complete action-todo btn-disable" : 'btn-action btn-complete action-todo btn-loading-inline') : "btn-action btn-complete action-todo"} onClick={this.openDialog.bind(this)}><span>Lưu hồ sơ</span></Link>
              </ShowIf>
            </div>
          </div>
        </ShowIf>
        <Dialog
          isOpen={this.state.showDoiTuongThanhTra}
          onClose={this.hideDoiTuongThanhTra.bind(this)}
          title={`Thông tin đối tượng ${this.checkIsKiemTra() ? 'kiểm tra' : 'thanh tra'}`}
          className="reception-dialog delete-dialog full-dialog"
        >
          {
            DataDetail.cuocThanhTraNhieuDoiTuong == true ? (
              <table className="blueTable">
                <thead>
                  <tr>
                    <th style={{ width: '35px' }}>STT</th>
                    <th style={{ width: '300px' }}>Tên đối tượng</th>
                    <th style={{ width: '165px' }}>Nhóm đối tượng</th>
                    <th style={{ width: '375px' }}>Địa chỉ</th>
                    <th style={{ width: '135px' }}>Số điện thoại</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    DataDetail.listDoiTuongThanhTra &&
                    DataDetail.listDoiTuongThanhTra.map((item, index) => {
                      return <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.ten}</td>
                        <td>{item.nhomDoiTuongThanhTraInfo && item.nhomDoiTuongThanhTraInfo.ten ? item.nhomDoiTuongThanhTraInfo.ten : ''}</td>
                        <td>{item.diaChi}</td>
                        <td>{item.soDienThoai || ''}</td>
                      </tr>
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div className="pt-dialog-body mb0">
                <div className='row pl15 pr15'>
                  <Text className='col-50 mb10' label='Tên đối tượng:' value={chiTietMotDoiTuong.ten || ''} />
                  <Text className='col-50 mb10' label='Nhóm đối tượng:' value={chiTietMotDoiTuong && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo && chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten ? chiTietMotDoiTuong.nhomDoiTuongThanhTraInfo.ten : ''} />
                  <Text className='col-50 mb10' label='Địa chỉ:' value={chiTietMotDoiTuong.diaChi || ''} />
                  <Text className='col-50 mb10' label="Số điện thoại:" value={chiTietMotDoiTuong && chiTietMotDoiTuong.soDienThoai ? chiTietMotDoiTuong.soDienThoai : ''} />
                </div>
              </div>
            )
          }
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.hideDoiTuongThanhTra.bind(this)}><span>Đóng</span></Link>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.confirmDoiTuongViPham}
          onClose={this.closeConfirmDoiTuongViPham.bind(this)}
          title='Xác nhận'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">Đối tượng này đang được sử dụng, xác nhận xóa</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeConfirmDoiTuongViPham.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.accessConfirmDoiTuongViPham.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>

        <Dialog
          isOpen={this.state.confirmDoiTuongLienQuan}
          onClose={this.closeConfirmDoiTuongLienQuan.bind(this)}
          title='Xác nhận'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">Đối tượng này đang được sử dụng, xác nhận xóa</p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeConfirmDoiTuongLienQuan.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.accessConfirmDoiTuongLienQuan.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
        <Dialog
          isOpen={this.state.openDialog}
          onClose={this.closeDialog.bind(this)}
          title='Xác nhận'
          className="reception-dialog delete-dialog wrap-block"
        >
          <div className="pt-dialog-body">
            <p className="reception-dialog-text">
              {
                (this.state.noiDungKienNghi === true && userInfo.capCoQuanQuanLyId !== TTTrungUong && !this.checkIsKiemTra()) ? "Xác nhận chuyển theo dõi thực hiện" : "Xác nhận lưu hồ sơ"
              }
            </p>
          </div>
          <div className="box-bottom col-100">
            <Link className="btn-action btn-close action-todo" onClick={this.closeDialog.bind(this)}><span>Không</span></Link>
            <Link className="btn-green" onClick={this.handleKetThuc.bind(this)}><span>Đồng ý</span></Link>
          </div>
        </Dialog>
      </div>
    );
  }
}

ChinhSuaCuocThanhTra.defaultProps = {
  validators: {
    formTaoDon: []
  },
  params: {
    id: ''
  }
}

export default ChinhSuaCuocThanhTra;



// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/ChinhSuaCuocThanhTra.jsx